/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
    i,
    q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;
  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
    i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }
  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var PRODUCT_TYPES_BASE = {
  // type_id          : ProductClass
  accessory: 'Accessory',
  accessory_configurable: 'Accessory',
  box: 'Box',
  edp: 'Edp',
  edpFms: 'EdpFms',
  faim: 'Faim',
  faim_premium: 'FaimPremium',
  faim_unlimited: 'FaimUnlimited',
  fai_box_generique: 'FaiBox',
  fai: 'Fai',
  fai_service: 'Activation',
  fai_fmd: 'Installation',
  insurance: 'Insurance',
  option: 'Option',
  option_fai: 'Option',
  option_salable: 'OptionSalable',
  option_partner: 'OptionPartner',
  option_remise: 'OptionRemise',
  offer_partner: 'OptionPartner',
  odr: 'Odr',
  plan_ideo: 'Ideo',
  plan_ideo_pro: 'Ideo',
  plan_omb: 'Omb',
  plan_simo: 'Simo',
  plan_sowo: 'Sowo',
  plan_sowo_renew: 'Sowo',
  plan_premium: 'Sensation',
  plan_premium_renew: 'Sensation',
  phone_simple: 'Phone',
  phone: 'Phone',
  sim: 'Sim',
  qr_esim: 'Sim',
  shipping: 'Delivery',
  _subscription: 'Subscription',
  _equipement: 'Equipment',
  _plan: 'Plan',
  _product: 'Product',
  'mobile-take-back': 'MobileTakeBack'
};
var PRICE_TYPES = /*#__PURE__*/function (PRICE_TYPES) {
  PRICE_TYPES[PRICE_TYPES["Today"] = 0] = "Today";
  PRICE_TYPES[PRICE_TYPES["EveryMonth"] = 1] = "EveryMonth";
  PRICE_TYPES[PRICE_TYPES["Other"] = 2] = "Other";
  PRICE_TYPES[PRICE_TYPES["Reported"] = 3] = "Reported";
  PRICE_TYPES[PRICE_TYPES["EvryMonthIncluded"] = 4] = "EvryMonthIncluded";
  return PRICE_TYPES;
}(PRICE_TYPES || {});
var Prices = /** @class */function () {
  function Prices(base, final, forever, duration) {
    if (base === void 0) {
      base = 0;
    }
    if (final === void 0) {
      final = base;
    }
    if (forever === void 0) {
      forever = final;
    }
    this.base = base;
    this.final = final;
    this.forever = forever;
    this.duration = duration;
  }
  Prices.prototype.add = function (prices) {
    this.final = +(this.final + prices.final).toFixed(2) || 0;
    this.forever = +(this.forever + prices.forever).toFixed(2) || 0;
    this.base = +(this.base + prices.base).toFixed(2) || 0;
    if (prices.duration) {
      this.duration = prices.duration;
    }
    return this;
  };
  return Prices;
}();
var REDUCTION_TYPE = /*#__PURE__*/function (REDUCTION_TYPE) {
  REDUCTION_TYPE[REDUCTION_TYPE["FIX"] = 0] = "FIX";
  REDUCTION_TYPE[REDUCTION_TYPE["POURCENT"] = 1] = "POURCENT";
  return REDUCTION_TYPE;
}(REDUCTION_TYPE || {});
var TYPE_MARKETING = /*#__PURE__*/function (TYPE_MARKETING) {
  TYPE_MARKETING["CONVERGENCE"] = "CONVERGENCE";
  TYPE_MARKETING["MULTILIGNES"] = "MULTILIGNES";
  TYPE_MARKETING["PORTABILITE"] = "PORTABILITE";
  TYPE_MARKETING["CODE_POSTAL_ELIGIBILITE_FIXE"] = "CODE_POSTAL_ELIGIBILITE_FIXE";
  TYPE_MARKETING["SOLDES"] = "SOLDES";
  TYPE_MARKETING["FOYER"] = "FOYER";
  return TYPE_MARKETING;
}(TYPE_MARKETING || {});
var ACCESS_TYPE = /*#__PURE__*/function (ACCESS_TYPE) {
  ACCESS_TYPE["PROSPECT"] = "PROSPECT";
  ACCESS_TYPE["CLIENT"] = "CLIENT";
  ACCESS_TYPE["GP"] = "GP";
  ACCESS_TYPE["PRO"] = "PRO";
  ACCESS_TYPE["PORTABILITE"] = "PORTABILITE";
  ACCESS_TYPE["INCITATION"] = "INCITATION";
  ACCESS_TYPE["CONVERGENCE"] = "CONVERGENCE";
  return ACCESS_TYPE;
}(ACCESS_TYPE || {});
var MARKET_TYPE = /*#__PURE__*/function (MARKET_TYPE) {
  MARKET_TYPE["PORTA"] = "PORTABILITY";
  return MARKET_TYPE;
}(MARKET_TYPE || {});
var PromotionModel = /** @class */function () {
  function PromotionModel(data) {
    this.data = data;
    this.isEligibleEdp = true;
    this.typesMarketing = [];
    this.accessTypes = [];
    Object.assign(this, data);
  }
  PromotionModel.prototype.clone = function () {
    return new PromotionModel(this.data);
  };
  PromotionModel.prototype.getAmount = function (price) {
    if (this.reductionType === REDUCTION_TYPE.FIX) {
      return this.amount;
    } else {
      return this.amount * price / 100;
    }
  };
  PromotionModel.prototype.equal = function (promotion) {
    var _this = this;
    return promotion && this.amount === promotion.amount && this.code === promotion.code && this.type === promotion.type && this.relevantProducts.every(function (p) {
      return promotion.relevantProducts.includes(p);
    }) && promotion.relevantProducts.every(function (p) {
      return _this.relevantProducts.includes(p);
    });
  };
  return PromotionModel;
}();
var PromotionOdrModel = /** @class */function (_super) {
  __extends(PromotionOdrModel, _super);
  function PromotionOdrModel(data) {
    var _this = _super.call(this, data) || this;
    Object.assign(_this, data);
    return _this;
  }
  return PromotionOdrModel;
}(PromotionModel);
var PromotionsModel = /** @class */function () {
  function PromotionsModel(automatic, manual, incitation, coupon) {
    this.automatic = automatic || [];
    this.manual = manual || [];
    this.incitation = incitation || [];
    this.coupon = coupon || null;
  }
  PromotionsModel.roundPrice = function (price) {
    return +(Math.floor(+(price * 100).toFixed(1)) / 100).toFixed(2);
  };
  PromotionsModel.prototype.clone = function () {
    var _a;
    return new PromotionsModel(this.automatic.map(function (a) {
      return a.clone();
    }), this.manual.map(function (m) {
      return m.clone();
    }), this.incitation.map(function (i) {
      return i.clone();
    }), (_a = this.coupon) === null || _a === void 0 ? void 0 : _a.clone());
  };
  PromotionsModel.prototype.canHaveEdp = function () {
    return !this.automatic.some(function (promotion) {
      return !promotion.isEligibleEdp;
    }) && !this.manual.some(function (promotion) {
      return !promotion.isEligibleEdp;
    });
  };
  PromotionsModel.prototype.getDuration = function (withIncitation, withOdr) {
    if (withIncitation === void 0) {
      withIncitation = false;
    }
    if (withOdr === void 0) {
      withOdr = false;
    }
    var firstFoundPromoDuration = __spreadArray(__spreadArray(__spreadArray([], __read(this.automatic), false), __read(this.manual), false), __read(withIncitation ? this.incitation : []), false).filter(function (promo) {
      return promo instanceof PromotionOdrModel && withOdr || !(promo instanceof PromotionOdrModel);
    }).sort(function (a, b) {
      return b.duration - a.duration;
    })[0];
    return firstFoundPromoDuration ? +firstFoundPromoDuration.duration : null;
  };
  PromotionsModel.prototype.getPrices = function (basePrice, minPrice, withIncitation, withOdr) {
    if (minPrice === void 0) {
      minPrice = 0;
    }
    if (withIncitation === void 0) {
      withIncitation = false;
    }
    if (withOdr === void 0) {
      withOdr = false;
    }
    var price = basePrice;
    var priceForever = basePrice;
    var promoAuto = this.automatic.filter(function (promo) {
      return promo instanceof PromotionOdrModel && withOdr || !(promo instanceof PromotionOdrModel);
    });
    price -= this._getAmountWithPromotions(price, promoAuto);
    priceForever -= this._getAmountWithPromotions(price, promoAuto.filter(function (p) {
      return p.duration === 0;
    }));
    var promoManual = this.manual.filter(function (promo) {
      return !withOdr || !(promo instanceof PromotionOdrModel);
    });
    price -= this._getAmountWithPromotions(price, promoManual);
    priceForever -= this._getAmountWithPromotions(price, promoManual.filter(function (p) {
      return p.duration === 0;
    }));
    if (withIncitation) {
      var promoIncitation = this.incitation.filter(function (promo) {
        return !withOdr || !(promo instanceof PromotionOdrModel);
      });
      price -= this._getAmountWithPromotions(price, promoIncitation);
      priceForever -= this._getAmountWithPromotions(price, promoIncitation.filter(function (p) {
        return p.duration === 0;
      }));
    }
    var couponPrice = this.coupon ? this.coupon.getAmount(price) : 0;
    return new Prices(basePrice, Math.max(minPrice, PromotionsModel.roundPrice(price - couponPrice)), Math.max(minPrice, PromotionsModel.roundPrice(priceForever)), this.getDuration(withIncitation, withOdr));
  };
  PromotionsModel.prototype.removeManual = function (promotion) {
    this.manual = this.manual.filter(function (promo) {
      return promo.id !== promotion.id;
    });
  };
  PromotionsModel.prototype.addManual = function (promotion) {
    if (this.manual.some(function (p) {
      return p.id === promotion.id;
    })) {
      return false;
    }
    this.manual.push(promotion);
    return true;
  };
  PromotionsModel.prototype.setCoupon = function (coupon) {
    this.coupon = coupon;
  };
  PromotionsModel.prototype.removeCoupon = function () {
    this.coupon = null;
  };
  PromotionsModel.prototype._getAmountWithPromotions = function (price, promos) {
    return promos.reduce(function (acc, promotion) {
      return acc + promotion.getAmount(price);
    }, 0);
  };
  return PromotionsModel;
}();
var Product = /** @class */function () {
  function Product(data) {
    this.isPrincipal = false;
    this.position = 0;
    this.rules = {
      incompatible: [],
      related: [],
      mandatory: [],
      maxQuantity: 0
    };
    this.total = 0;
    this.productLine = 'Autres';
    this.gamme = '';
    this.priceType = PRICE_TYPES.EveryMonth;
    this.promotions = new PromotionsModel([], [], []);
    this.autoAdd = [];
    this.medias = [];
    this.isPro = false;
    this.proLabel = '';
    this.minPromoPrice = 0;
    this.crossSells = [];
    this.upSells = [];
    this.related = [];
    this.categories = [];
    this.data = data;
    this.gencode = data.gencode;
    this.name = data.name;
    this.medias = data.medias;
    this.autoAdd = this.data.auto_add_front ? this.data.auto_add_front.split(',') : [];
    this.prices = new Prices(data.price);
    this.image = this.data.image;
    this.smallImage = this.data.small_image;
    this.imageHD = this.data.imageHd;
    this.maxQty = this.data.max_qty;
    this.wallurl = this.data.type_id;
    this.label = this.data.name;
    this.crossSells = data.crossSellsProducts ? data.crossSellsProducts.map(function (c) {
      return c.hasOwnProperty('gencode') ? c.gencode : c;
    }) : [];
    this.upSells = data.upSellsProducts ? data.upSellsProducts.map(function (u) {
      return u.hasOwnProperty('gencode') ? u.gencode : u;
    }) : [];
    this.related = data.relatedProduct || [];
    this.categories = data.categories || [];
    this.autoAddFront = this.data.to_add_front ? JSON.parse(this.data.to_add_front) : [];
    this.setRules();
  }
  Product.prototype.canAdd = function (quote) {
    var _this = this;
    // QTY max de produit de type XXX en fonction de l'attr de la class maxQuantity
    if (this.rules.maxQuantity) {
      var sameTypeProductsQty = quote.products.filter(function (product) {
        return product.data.type_id === _this.data.type_id;
      }).length;
      if (sameTypeProductsQty + 1 > this.rules.maxQuantity) {
        throw new Error("Vous avez atteint la limite autoris\u00E9e (".concat(this.rules.maxQuantity, ") pour ce type de produit"));
      }
    }
    // QTY max de produit du même gencode en fonction de data.max_qty
    if (this.data.max_qty) {
      var sameGencodeProductsQty = quote.products.filter(function (product) {
        return !_this.rules.incompatible.includes(PRODUCT_TYPES_BASE[product.data.type_id]) && product.data.gencode === _this.data.gencode;
      }).length;
      if (sameGencodeProductsQty + 1 > this.data.max_qty) {
        throw new Error("Vous avez atteint la limite autoris\u00E9e (".concat(this.data.max_qty, ") pour ce type de produit"));
      }
    }
    return true;
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Product.prototype.beforeAdd = function (quoteService, quote) {
    // This is intentional
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Product.prototype.afterAdd = function (quoteService, quote) {
    // This is intentional
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Product.prototype.afterRemove = function (quoteService, quote) {
    // This is intentional
  };
  Product.prototype.getIncompatible = function (quote) {
    return this.rules.incompatible.reduce(function (acc, product) {
      return __spreadArray(__spreadArray([], __read(acc), false), __read(quote.getProductsByType(product, true)), false);
    }, []);
  };
  Product.prototype.getRelated = function (quote) {
    var _this = this;
    return __spreadArray([], __read(this.rules.related.map(function (product) {
      return quote.getProductsByType(product);
    }).reduce(function (acc, products) {
      products.forEach(function (p) {
        return acc.add(p);
      });
      quote.products.filter(function (product) {
        return _this.crossSells.includes(product.gencode) || _this.upSells.includes(product.gencode);
      }).forEach(function (p) {
        return acc.add(p);
      });
      return acc;
    }, new Set())), false);
  };
  /**
   * Retrieve products that should be automatically added to the quote
   * @param quote currentQuote
   * @returns Array of product
   */
  Product.prototype.getAutoAdded = function (quote) {
    var autoAddedProducts = new Set();
    this.autoAddFront.forEach(function (autoAdd) {
      autoAdd.alternatives.forEach(function (gencode) {
        var product = quote.getProductByGencode(gencode);
        if (product) {
          autoAddedProducts.add(product);
        }
      });
    });
    return Array.from(autoAddedProducts);
  };
  Product.prototype.keepProduct = function (quote, product) {
    return this.crossSells.includes(product.gencode);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Product.prototype.onItemAddedInQuote = function (quote, product) {
    // This is intentional
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Product.prototype.onItemRemovedFromQuote = function (quote, product) {
    // This is intentional
  };
  Product.prototype.calculatePrices = function (quote, promotions) {
    this.promotions = promotions;
    this.prices = this.promotions.getPrices(this.prices.base, this.minPromoPrice);
  };
  Product.prototype.refresh = function (quoteService, quote) {
    this.removeProductByPromotions(quoteService, quote);
  };
  Product.prototype.getPrice = function () {
    return this.prices.final;
  };
  Product.prototype.isInStock = function () {
    var _a;
    return !!((_a = this.data) === null || _a === void 0 ? void 0 : _a.in_stock);
  };
  Product.prototype.clone = function () {
    // @ts-ignore
    return new this.constructor(this.data);
  };
  Product.prototype.removeProductByPromotions = function (quoteService, quote) {
    if (quote.getProductsByType('Edp') && !this.promotions.canHaveEdp()) {
      quoteService.removeProductsByType(quote, 'Edp');
    }
  };
  Product.prototype.setRules = function () {
    // This is intentional
  };
  return Product;
}();
var IS_LOADING_CLASS = 'is-loading';
var SIM_PORTABILITY = /*#__PURE__*/function (SIM_PORTABILITY) {
  SIM_PORTABILITY["PORTABILITY"] = "aUnePortabilite";
  SIM_PORTABILITY["NO_PORTABILITY"] = "nAPasDePortabilite";
  return SIM_PORTABILITY;
}(SIM_PORTABILITY || {});
var OPTION_LOCKED_ID = '12782';
var ERRORS_LEVELS = /*#__PURE__*/function (ERRORS_LEVELS) {
  ERRORS_LEVELS["warning"] = "warning";
  ERRORS_LEVELS["error"] = "danger";
  ERRORS_LEVELS["info"] = "info";
  return ERRORS_LEVELS;
}(ERRORS_LEVELS || {});
var Equipment = /** @class */function (_super) {
  __extends(Equipment, _super);
  function Equipment(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.childGencode = [];
    _this.minPromoPrice = 1;
    _this.priceType = PRICE_TYPES.Today;
    _this.manufacturer = data.manufacturer;
    _this.maxConnection = data.max_connection;
    _this.childGencode = data.product_ids || _this.childGencode;
    _this.color = data.color || _this.color;
    _this.colorCode = data.color_code || _this.colorCode;
    _this.capacity = data.capacity || _this.capacity;
    _this.state = data.state;
    return _this;
  }
  Equipment.prototype.setRules = function () {
    this.rules.related = this.rules.related.concat(Equipment.RELATED_PRODUCTS);
    this.rules.incompatible = this.rules.incompatible.concat(Equipment.INCOMPATIBLE_PRODUCTS);
  };
  Equipment.INCOMPATIBLE_PRODUCTS = [];
  Equipment.RELATED_PRODUCTS = ['Insurance'];
  return Equipment;
}(Product);
var QUOTE_CONTEXTS = /*#__PURE__*/function (QUOTE_CONTEXTS) {
  QUOTE_CONTEXTS["ACQUISITION"] = "ACQUISITION";
  QUOTE_CONTEXTS["ACQUISITIONFIX"] = "ACQUISITIONFIX";
  QUOTE_CONTEXTS["RENEW"] = "RENOUVELLEMENT";
  return QUOTE_CONTEXTS;
}(QUOTE_CONTEXTS || {});
var UPDATE_ACTIONS = /*#__PURE__*/function (UPDATE_ACTIONS) {
  UPDATE_ACTIONS["ADD"] = "add";
  UPDATE_ACTIONS["REMOVE"] = "remove";
  return UPDATE_ACTIONS;
}(UPDATE_ACTIONS || {});
var RENEW_CLIENT_TYPES = /*#__PURE__*/function (RENEW_CLIENT_TYPES) {
  RENEW_CLIENT_TYPES["COLLABORATOR"] = "collaborator";
  RENEW_CLIENT_TYPES["CLIENT"] = "client";
  return RENEW_CLIENT_TYPES;
}(RENEW_CLIENT_TYPES || {});
var RENEW_NB_TERMS = /*#__PURE__*/function (RENEW_NB_TERMS) {
  RENEW_NB_TERMS["MONTH12"] = "month12";
  RENEW_NB_TERMS["MONTH18"] = "month18";
  RENEW_NB_TERMS["MONTH24"] = "month24";
  return RENEW_NB_TERMS;
}(RENEW_NB_TERMS || {});
var QuoteContextModel = /** @class */function () {
  function QuoteContextModel(params) {
    if (params === void 0) {
      params = {};
    }
    this.params = params;
    Object.assign(this, params);
  }
  QuoteContextModel.prototype.getData = function () {
    return {
      id: this.id
    };
  };
  return QuoteContextModel;
}();
var QuoteContextRenewalModel = /** @class */function (_super) {
  __extends(QuoteContextRenewalModel, _super);
  function QuoteContextRenewalModel(params) {
    var _this = _super.call(this, params) || this;
    _this.params = params;
    _this.id = QUOTE_CONTEXTS.RENEW;
    return _this;
  }
  QuoteContextRenewalModel.prototype.clone = function () {
    return new QuoteContextRenewalModel(this.params);
  };
  QuoteContextRenewalModel.prototype.getData = function () {
    return {
      id: this.id,
      contractId: this.contractId,
      clientType: this.clientType,
      nbTerms: this.nbTerms
    };
  };
  return QuoteContextRenewalModel;
}(QuoteContextModel);
var Subscription$1 = /** @class */function (_super) {
  __extends(Subscription, _super);
  function Subscription(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.priceType = PRICE_TYPES.EveryMonth;
    return _this;
  }
  Subscription.prototype.updatePromotions = function () {
    // This is intentional
  };
  return Subscription;
}(Product);
var Plan = /** @class */function (_super) {
  __extends(Plan, _super);
  function Plan(data, isPro) {
    if (isPro === void 0) {
      isPro = false;
    }
    var _this = this;
    var categoriesSet = new Set(['fai', 'faim_unlimited']);
    var shouldAddForfaitLabel = !data.categories.some(function (category) {
      return categoriesSet.has(category);
    });
    _this = _super.call(this, data) || this;
    _this.data = data;
    _this.isPro = isPro;
    _this.hasPorta = true;
    _this.iconInfos = {
      name: 'forfait-byou'
    };
    _this.isPremium = false;
    _this.isPrincipal = true;
    _this.isAssos = false;
    _this.portabilityEnable = false;
    _this.isPro = data.exclu_pro || false;
    _this.isAssos = data.exclu_assos || false;
    _this.label = "".concat(shouldAddForfaitLabel ? 'Forfait ' : '').concat(_this.data.name);
    _this.proLabel = "Forfait Pro ".concat(_this.data.name);
    _this.productPrio = data.produit_prioritaire;
    return _this;
  }
  Plan.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = this.rules.incompatible.concat(Plan.INCOMPATIBLE_PRODUCTS);
    this.rules.related = this.rules.related.concat(Plan.RELATED_PRODUCTS);
  };
  Plan.INCOMPATIBLE_PRODUCTS = ['Sowo', 'Simo', 'Omb', 'Sensation', 'Faim', 'Fai', 'FaimPremium', 'FaimUnlimited', 'Ideo'];
  Plan.RELATED_PRODUCTS = ['Option', 'Sim'];
  return Plan;
}(Subscription$1);
var Phone = /** @class */function (_super) {
  __extends(Phone, _super);
  function Phone(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.isPrincipal = true;
    _this.productLine = 'Terminaux';
    _this.availableEdp = false;
    _this.priceContext = {};
    _this.priceContext[QUOTE_CONTEXTS.ACQUISITION] = 'acquisition';
    _this.priceContext[QUOTE_CONTEXTS.RENEW] = 'renew';
    _this.isPro = !!(data === null || data === void 0 ? void 0 : data.exclu_pro);
    return _this;
  }
  Phone.prototype.onItemAddedInQuote = function (quote, product) {
    this._updateSpecialPrices(quote);
    _super.prototype.onItemAddedInQuote.call(this, quote, product);
  };
  Phone.prototype.onItemRemovedFromQuote = function (quote, product) {
    this._updateSpecialPrices(quote);
    _super.prototype.onItemRemovedFromQuote.call(this, quote, product);
  };
  Phone.prototype.refresh = function (quoteService, quote) {
    this._updateSpecialPrices(quote);
    _super.prototype.refresh.call(this, quoteService, quote);
  };
  Phone.prototype.calculatePrices = function (quote, promotions) {
    _super.prototype.calculatePrices.call(this, quote, promotions);
    this._updateEdpPrice(quote);
  };
  Phone.prototype.getEdpData = function (quote) {
    var _a, _b;
    var plan = quote.getProductByType('Plan');
    var phone = quote.getProductByType('Phone');
    if (!phone || !plan) {
      return null;
    }
    var basePriceData = (_b = (_a = phone.data) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b.plans[plan.gencode];
    var specialPriceData;
    if (quote.context instanceof QuoteContextRenewalModel) {
      specialPriceData = this._handleRenewalData(quote, phone, plan, basePriceData);
    } else if (basePriceData) {
      specialPriceData = this._getEdpPlanData(phone, plan);
    }
    return specialPriceData;
  };
  Phone.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = this.rules.incompatible.concat(Phone.INCOMPATIBLE_PRODUCTS);
    this.rules.related = Equipment.RELATED_PRODUCTS.concat(Phone.RELATED_PRODUCTS);
  };
  Phone.prototype._handleRenewalData = function (quote, phone, plan, basePriceData) {
    var _a, _b, _c;
    var context = quote.context;
    var nbTerms = context.nbTerms;
    var planSowo = quote.getProductByType('Sowo');
    var specialPriceData;
    if (!nbTerms) {
      // Actual SOWO
      return planSowo ? this._getEdpPhoneData(phone) : this._getEdpPlanData(phone, plan);
    } else {
      // Actual SAS
      var clientTypeData = (_a = basePriceData === null || basePriceData === void 0 ? void 0 : basePriceData.renew) === null || _a === void 0 ? void 0 : _a[context.clientType];
      specialPriceData = clientTypeData ? clientTypeData[nbTerms] : (_c = (_b = basePriceData === null || basePriceData === void 0 ? void 0 : basePriceData.renew) === null || _b === void 0 ? void 0 : _b[RENEW_CLIENT_TYPES.CLIENT]) === null || _c === void 0 ? void 0 : _c[nbTerms];
      if (specialPriceData) {
        specialPriceData.edp = basePriceData === null || basePriceData === void 0 ? void 0 : basePriceData.edp;
      }
    }
    return specialPriceData;
  };
  Phone.prototype._getEdpPhoneData = function (phone) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      edp_price: (_b = (_a = phone.data) === null || _a === void 0 ? void 0 : _a.edp_phone) === null || _b === void 0 ? void 0 : _b.price,
      price: ((_d = (_c = phone.data) === null || _c === void 0 ? void 0 : _c.edp_phone) === null || _d === void 0 ? void 0 : _d.price) + ((_f = (_e = phone.data) === null || _e === void 0 ? void 0 : _e.edp_phone) === null || _f === void 0 ? void 0 : _f.amount) * ((_g = phone.data) === null || _g === void 0 ? void 0 : _g.edp_phone.duration),
      edp: (_h = phone.data) === null || _h === void 0 ? void 0 : _h.edp_phone
    };
  };
  Phone.prototype._getEdpPlanData = function (phone, plan) {
    var _a, _b;
    var basePriceData = (_b = (_a = phone.data) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b.plans[plan.gencode];
    var specialPriceData = basePriceData.acquisition;
    specialPriceData.edp = basePriceData.edp;
    return specialPriceData;
  };
  Phone.prototype._updateSpecialPrices = function (quote) {
    var _a;
    var plan = quote.getProductByType(Plan);
    if (plan) {
      var specialPriceData = this.getEdpData(quote);
      this.rsfPdf = specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.rsfPdf;
      if (specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.price) {
        // price with premium plan
        this.prices.base = specialPriceData.price;
        this.prices.final = specialPriceData.price;
        this.rsfAmount = (_a = specialPriceData.rsfAmount) !== null && _a !== void 0 ? _a : 0;
      } else {
        this.prices.base = this.data.price;
        this.prices.final = this.data.price;
      }
    }
  };
  Phone.prototype._updateEdpPrice = function (quote) {
    var edp = quote.getProductByType('Edp');
    var specialPriceData = this.getEdpData(quote);
    this.availableEdp = !!(specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.edp_price) && this.promotions.canHaveEdp();
    if (edp && (specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.edp_price)) {
      // price with EDP
      this.prices.base = specialPriceData.edp_price;
      this.prices.final = Math.max(this.minPromoPrice, +(this.prices.final - specialPriceData.edp.amount * specialPriceData.edp.duration).toFixed(2));
    }
  };
  Phone.INCOMPATIBLE_PRODUCTS = ['Faim', 'FaimPremium', 'FaimUnlimited', 'Box', 'Phone', 'Fai'];
  Phone.RELATED_PRODUCTS = ['Edp'];
  return Phone;
}(Equipment);
var Box = /** @class */function (_super) {
  __extends(Box, _super);
  function Box() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isPrincipal = true;
    _this.productLine = 'FAI';
    return _this;
  }
  Box.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Equipment.INCOMPATIBLE_PRODUCTS.concat(Box.INCOMPATIBLE_PRODUCTS);
  };
  Box.INCOMPATIBLE_PRODUCTS = ['Sowo', 'Sensation', 'Phone', 'Box', 'Fai'];
  return Box;
}(Phone);
var Accessory = /** @class */function (_super) {
  __extends(Accessory, _super);
  function Accessory() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.productLine = 'Accessoires';
    _this.minPromoPrice = 0;
    _this.essential = false;
    return _this;
  }
  Accessory.prototype.setRules = function () {
    this.rules.related = [];
    this.rules.incompatible = [];
    this.rules.maxQuantity = 5;
  };
  return Accessory;
}(Equipment);
var Activation = /** @class */function (_super) {
  __extends(Activation, _super);
  function Activation(data) {
    var _this = this;
    var _a;
    _this = _super.call(this, data) || this;
    _this.data = data;
    _this.minPromoPrice = 0;
    _this.data.type = 'activation';
    _this.priceType = !!((_a = _this.data) === null || _a === void 0 ? void 0 : _a.price_type) ? PRICE_TYPES.Reported : PRICE_TYPES.Today;
    return _this;
  }
  Activation.prototype.refresh = function (quoteService, quote) {
    if (quote.getProductByType('EdpFms')) {
      this.prices.base = 0;
    } else {
      this.prices.base = this.data.price || 0;
    }
    _super.prototype.refresh.call(this, quoteService, quote);
  };
  return Activation;
}(Equipment);
var Delivery = /** @class */function (_super) {
  __extends(Delivery, _super);
  function Delivery(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.export = false;
    _this.priceType = data.price_type;
    return _this;
  }
  Delivery.prefillData = function (deliveryData) {
    return {
      incompatible_with: [],
      auto_add_front: '',
      ecotax: 0,
      entity_id: 0,
      final_price: deliveryData.prix,
      in_stock: true,
      max_qty: 1,
      name: deliveryData.libelle,
      price: deliveryData.prix,
      qty: 1,
      sku: deliveryData.gencode,
      type: 'Delivery',
      type_id: 'shipping',
      url: '',
      url_key: '',
      gencode: deliveryData.gencode,
      price_type: deliveryData.typePrix
    };
  };
  Delivery.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Delivery.INCOMPATIBLE_PRODUCTS;
  };
  Delivery.INCOMPATIBLE_PRODUCTS = ['Delivery'];
  return Delivery;
}(Product);
var FaiBox = /** @class */function (_super) {
  __extends(FaiBox, _super);
  function FaiBox(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.isPrincipal = true;
    _this.productLine = 'FAI';
    _this.priceType = PRICE_TYPES.EveryMonth;
    _this.data.type = 'faiBox';
    _this.label = 'Frais de location';
    _this.wallurl = 'fai_result';
    return _this;
  }
  FaiBox.prototype.setRules = function () {
    this.rules.related = this.rules.related.concat(FaiBox.RELATED_PRODUCTS);
  };
  FaiBox.RELATED_PRODUCTS = ['Fai', 'FaimUnlimited'];
  return FaiBox;
}(Equipment);
var Installation = /** @class */function (_super) {
  __extends(Installation, _super);
  function Installation(data) {
    var _this = this;
    var _a;
    _this = _super.call(this, data) || this;
    _this.data = data;
    _this.priceType = !!((_a = _this.data) === null || _a === void 0 ? void 0 : _a.price_type) ? PRICE_TYPES.Reported : PRICE_TYPES.Today;
    return _this;
  }
  return Installation;
}(Equipment);
var MobileTakeBack = /** @class */function (_super) {
  __extends(MobileTakeBack, _super);
  function MobileTakeBack(data) {
    var _this = _super.call(this, data) || this;
    _this.priceType = PRICE_TYPES.Other;
    _this.id = data.id;
    _this.name = data.name;
    _this.brand = data.brand;
    _this.partnerData = data.partnerData;
    return _this;
  }
  return MobileTakeBack;
}(Product);
var Insurance = /** @class */function (_super) {
  __extends(Insurance, _super);
  function Insurance(data) {
    var _this = _super.call(this, __assign(__assign({}, data), {
      name: 'Assurance mobile'
    })) || this;
    _this.productLine = 'Assurance';
    return _this;
  }
  Insurance.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Insurance.INCOMPATIBLE_PRODUCTS;
    this.rules.mandatory = Insurance.MANDATORY_PRODUCTS;
  };
  Insurance.INCOMPATIBLE_PRODUCTS = ['Insurance'];
  Insurance.MANDATORY_PRODUCTS = [{
    product: 'Equipment',
    message: 'Une assurance doit être ajoutée sur un équipement.'
  }];
  return Insurance;
}(Subscription$1);
var Option = /** @class */function (_super) {
  __extends(Option, _super);
  function Option(data) {
    var _this = _super.call(this, data) || this;
    _this.isPrincipal = false;
    _this.productLine = 'Options';
    _this.isPro = data.exclu_pro;
    _this.category = data.option_category;
    _this.promoCodePrice = +data.code_promo_price;
    return _this;
  }
  Option.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.mandatory = this.rules.mandatory.concat(Option.MANDATORY_PRODUCTS);
  };
  Option.MANDATORY_PRODUCTS = [{
    product: 'Plan',
    message: 'Une option doit être ajoutée sur un forfait.'
  }];
  return Option;
}(Subscription$1);
var Odr = /** @class */function (_super) {
  __extends(Odr, _super);
  function Odr() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return Odr;
}(Option);
var OptionPartner = /** @class */function (_super) {
  __extends(OptionPartner, _super);
  function OptionPartner() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return OptionPartner;
}(Option);
var OptionRemise = /** @class */function (_super) {
  __extends(OptionRemise, _super);
  function OptionRemise() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return OptionRemise;
}(Option);
var OptionSalable = /** @class */function (_super) {
  __extends(OptionSalable, _super);
  function OptionSalable() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return OptionSalable;
}(Option);
var Sowo = /** @class */function (_super) {
  __extends(Sowo, _super);
  function Sowo() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.iconInfos = {
      name: 'B&You'
    };
    _this.isPrincipal = true;
    _this.productLine = 'Forfaits_mobile';
    _this.gamme = 'B&You';
    return _this;
  }
  Sowo.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Plan.INCOMPATIBLE_PRODUCTS.concat(Sowo.INCOMPATIBLE_PRODUCTS);
  };
  Sowo.INCOMPATIBLE_PRODUCTS = ['Box'];
  return Sowo;
}(Plan);
var Faim = /** @class */function (_super) {
  __extends(Faim, _super);
  function Faim() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.iconInfos = {
      name: 'Internet pour clé 4G'
    };
    _this.hasPorta = false;
    _this.productLine = 'Forfaits_mobile';
    _this.gamme = 'Faim';
    return _this;
  }
  Faim.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Plan.INCOMPATIBLE_PRODUCTS.concat(Faim.INCOMPATIBLE_PRODUCTS);
  };
  Faim.INCOMPATIBLE_PRODUCTS = ['Phone'];
  return Faim;
}(Sowo);
var Omb = /** @class */function (_super) {
  __extends(Omb, _super);
  function Omb(data) {
    var _this = _super.call(this, data) || this;
    _this.iconInfos = {
      name: 'Prompto'
    };
    _this.isPrincipal = true;
    _this.productLine = 'Forfaits_mobile';
    _this.gamme = 'Prompto';
    data.type_id = 'plan_omb';
    data.type = 'plan_omb';
    _this.wallurl = 'plan_omb';
    return _this;
  }
  return Omb;
}(Sowo);
var Simo = /** @class */function (_super) {
  __extends(Simo, _super);
  function Simo(data) {
    var _this = _super.call(this, data) || this;
    _this.iconInfos = {
      name: 'Sensation'
    };
    _this.isPrincipal = true;
    _this.productLine = 'Forfaits_mobile';
    _this.gamme = 'Sensation_SIM_seule';
    data.type_id = 'plan_simo';
    data.type = 'plan_simo';
    _this.wallurl = 'plan_simo';
    return _this;
  }
  return Simo;
}(Sowo);
var Fai = /** @class */function (_super) {
  __extends(Fai, _super);
  function Fai(data) {
    var _this = this;
    var _a;
    _this = _super.call(this, data) || this;
    _this.data = data;
    _this.isPrincipal = true;
    _this.productLine = 'FAI';
    _this.play = data.play;
    _this.technology = (_a = data.technology) !== null && _a !== void 0 ? _a : '';
    _this.range = data.range;
    _this.isPro = data.fai_category_type === 'offre_pro';
    _this.wallurl = "".concat(_this.data.type_id, "_result");
    _this.equipment = _this.data.equipment;
    _this.play = data.play;
    _this.commercial_partner = data.commercial_partner || 'none';
    return _this;
  }
  Fai.prototype.getLabelDaily = function () {
    return 'Frais de mise en service';
  };
  Fai.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Plan.INCOMPATIBLE_PRODUCTS.concat(Fai.INCOMPATIBLE_PRODUCTS);
    this.rules.related = Plan.RELATED_PRODUCTS.concat(Fai.RELATED_PRODUCTS);
  };
  Fai.RANGES = {
    BTL: 'btl',
    LARGE: 'large',
    MEDIUM: 'medium',
    MIAMI: 'miami',
    MIAMI_PLUS: 'miami_plus',
    SENSATION: 'sensation',
    SMALL: 'small',
    STANDARD: 'standard',
    BBOX_SMART_TV: 'bbox_smart_tv',
    BBOX_SMART_TV_LARGE: 'bbox_smart_tv_large',
    SL_SMALL: 'sl_small',
    SL_MEDIUM: 'sl_medium',
    SL_LARGE: 'sl_large',
    SL_LARGE_SMART_TV: 'sl_large_smart_tv',
    SS_MEDIUM: 'ss_medium',
    SS_MEDIUM_BANQUE: 'ss_medium_banque',
    BBOX_TV_PLUS: 'bbox_tv_plus'
  };
  Fai.TECHNOLOGIES = {
    ADSL: 'ADSL',
    VDSL: 'VDSL',
    XDSL: 'XDSL',
    THD: 'THD',
    FTTH: 'FTTH',
    FTTLA: 'FTTLA',
    BOX_4G: 'BOX_4G',
    BOX_5G: 'BOX_5G'
  };
  Fai.INCOMPATIBLE_PRODUCTS = ['Box', 'Phone'];
  Fai.RELATED_PRODUCTS = ['Activation', 'Installation', 'FaiBox'];
  return Fai;
}(Plan);
var FaimUnlimited = /** @class */function (_super) {
  __extends(FaimUnlimited, _super);
  function FaimUnlimited(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.hasPorta = false;
    _this.play = '1P';
    _this.technology = _this.equipment = data.technology;
    _this.range = data.classification; // clean des range avec Otis mais laissé par soucis de retrocompatibilité
    _this.data.commercial_series = data.classification;
    return _this;
  }
  return FaimUnlimited;
}(Fai);
var Sensation = /** @class */function (_super) {
  __extends(Sensation, _super);
  function Sensation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.iconInfos = {
      name: 'Sensation'
    };
    _this.isPrincipal = true;
    _this.isPremium = true;
    _this.productLine = 'Forfaits_mobile';
    _this.gamme = 'Sensation_Avantages_Smartphone';
    return _this;
  }
  Sensation.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.related = this.rules.related.concat(Sensation.RELATED_PRODUCTS);
    this.rules.incompatible = this.rules.incompatible.concat(Sensation.INCOMPATIBLE_PRODUCTS);
    this.rules.mandatory = this.rules.mandatory.concat(Sensation.MANDATORY_PRODUCTS);
  };
  Sensation.MANDATORY_PRODUCTS = [{
    product: 'Phone',
    message: 'Le forfait Sensation Avantages Smartphone requiert un Téléphone.'
  }];
  Sensation.INCOMPATIBLE_PRODUCTS = ['Box'];
  Sensation.RELATED_PRODUCTS = ['Phone', 'Box'];
  return Sensation;
}(Plan);
var FaimPremium = /** @class */function (_super) {
  __extends(FaimPremium, _super);
  function FaimPremium() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.iconInfos = {
      name: 'Internet pour clé 4G'
    };
    _this.isPremium = true;
    _this.hasPorta = false;
    _this.productLine = 'Forfaits_mobile';
    return _this;
  }
  FaimPremium.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = FaimPremium.INCOMPATIBLE_PRODUCTS;
    this.rules.mandatory = FaimPremium.MANDATORY_PRODUCTS;
  };
  FaimPremium.MANDATORY_PRODUCTS = [{
    product: 'Box',
    message: 'Le forfait Faim Premium requiert une Box.'
  }];
  FaimPremium.INCOMPATIBLE_PRODUCTS = ['Sensation', 'Sowo', 'Omb', 'Simo', 'Faim', 'Phone', 'Fai', 'FaimPremium', 'FaimUnlimited'];
  return FaimPremium;
}(Sensation);
var Ideo = /** @class */function (_super) {
  __extends(Ideo, _super);
  function Ideo(data) {
    var _this = _super.call(this, data) || this;
    _this.iconInfos = {
      name: 'Ideo'
    };
    _this.isPrincipal = true;
    _this.productLine = 'Forfaits_mobile';
    _this.gamme = 'Ideo';
    return _this;
  }
  return Ideo;
}(Sensation);
var EdpFms = /** @class */function (_super) {
  __extends(EdpFms, _super);
  function EdpFms(data) {
    return _super.call(this, __assign(__assign({}, data), {
      type_id: 'edpFms',
      type: 'edpFms'
    })) || this;
  }
  EdpFms.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.mandatory = this.rules.mandatory.concat(EdpFms.MANDATORY_PRODUCTS);
    this.rules.incompatible = this.rules.incompatible.concat(EdpFms.INCOMPATIBLE_PRODUCTS);
  };
  EdpFms.MANDATORY_PRODUCTS = [{
    product: 'Activation',
    message: 'Ajout impossible.'
  }];
  EdpFms.INCOMPATIBLE_PRODUCTS = ['EdpFms'];
  return EdpFms;
}(Option);
var Edp = /** @class */function (_super) {
  __extends(Edp, _super);
  function Edp(data) {
    var _this = _super.call(this, Edp.prefillData(data)) || this;
    _this.export = false;
    _this.isPrincipal = false;
    return _this;
  }
  /**
   * Allows pre-filled data when creating an instace, no any
   * @memberof Edp
   */
  Edp.prefillData = function (edpData) {
    return __assign(__assign({
      auto_add_front: '',
      duration: 0,
      edp_price: 0,
      incompatible_with: [],
      max_qty: 0,
      price: 0
    }, edpData), {
      name: 'Facilité de paiement du téléphone',
      ecotax: 0,
      entity_id: 0,
      type_id: 'edp',
      type: 'edp',
      sku: 'EPD0000000',
      qty: 0,
      gencode: 'EPD0000000',
      position: null,
      iconInfos: {
        name: ''
      },
      final_price: 1,
      in_stock: true,
      url: '',
      url_key: ''
    });
  };
  Edp.prototype.canAdd = function (quote) {
    var plan = quote.getProductByType('Plan');
    var phone = quote.getProductByType(Phone);
    if (!phone || !plan) {
      return false;
    }
    var specialPriceData = phone.getEdpData(quote);
    return plan && phone && (specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.edp_price) && _super.prototype.canAdd.call(this, quote);
  };
  Edp.prototype.beforeAdd = function (quoteService, quote) {
    var _a, _b, _c;
    _super.prototype.beforeAdd.call(this, quoteService, quote);
    var phone = quote.getProductByType('Phone');
    if (!phone) {
      return;
    }
    var specialPriceData = phone.getEdpData(quote);
    this.data.duration = (_a = specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.edp) === null || _a === void 0 ? void 0 : _a.duration;
    this.data.edp_price = (_b = specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.edp) === null || _b === void 0 ? void 0 : _b.amount;
    this.data.price = (_c = specialPriceData === null || specialPriceData === void 0 ? void 0 : specialPriceData.edp) === null || _c === void 0 ? void 0 : _c.amount;
    this.prices = new Prices(this.data.edp_price, this.data.edp_price, this.data.edp_price, this.data.duration);
    this.data.name = "Facilit\u00E9 de paiement du t\u00E9l\u00E9phone pendant ".concat(this.data.duration, " mois");
  };
  Edp.prototype.getPriceMonthly = function () {
    return this.data.price;
  };
  Edp.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.mandatory = this.rules.mandatory.concat(Edp.MANDATORY_PRODUCTS);
    this.rules.incompatible = this.rules.incompatible.concat(Edp.INCOMPATIBLE_PRODUCTS);
  };
  Edp.MANDATORY_PRODUCTS = [{
    product: 'Equipment',
    message: 'Pas d\'EDP sans équipement possible.'
  }];
  Edp.INCOMPATIBLE_PRODUCTS = ['Edp'];
  return Edp;
}(Subscription$1);
var Sim = /** @class */function (_super) {
  __extends(Sim, _super);
  function Sim(data) {
    var _this = _super.call(this, data) || this;
    _this.data = data;
    _this.portabilityType = SIM_PORTABILITY.NO_PORTABILITY;
    _this.priceType = PRICE_TYPES.Today;
    return _this;
  }
  Sim.prototype.setPortabilityPrices = function (data) {
    this.portabilityPrices = data;
    return this;
  };
  Sim.prototype.refresh = function (quoteService, quote) {
    _super.prototype.refresh.call(this, quoteService, quote);
    this.updatePortabilityPrice(quote);
  };
  Sim.prototype.setRules = function () {
    _super.prototype.setRules.call(this);
    this.rules.incompatible = Sim.INCOMPATIBLE_PRODUCTS;
    this.rules.mandatory = Sim.MANDATORY_PRODUCTS;
  };
  Sim.prototype.updatePortabilityPrice = function (quote) {
    var _a;
    var plan = quote.getPrincipalProduct(Plan);
    if ((_a = plan === null || plan === void 0 ? void 0 : plan.portability) === null || _a === void 0 ? void 0 : _a.active) {
      this.portabilityType = SIM_PORTABILITY.PORTABILITY;
    } else {
      this.portabilityType = SIM_PORTABILITY.NO_PORTABILITY;
    }
    var simPrice = this.data.price;
    if (this.portabilityPrices && this.portabilityPrices[this.portabilityType]) {
      simPrice = this.portabilityPrices[this.portabilityType].price;
      this.priceType = this.portabilityPrices[this.portabilityType].type;
    } else {
      this.priceType = PRICE_TYPES.Today;
    }
    this.prices = new Prices(simPrice);
  };
  Sim.INCOMPATIBLE_PRODUCTS = ['Sim'];
  Sim.MANDATORY_PRODUCTS = [{
    product: 'Plan',
    message: 'La carte SIM requiert un forfait.'
  }];
  return Sim;
}(Product);
var _a;
// Mapping type_id (quote localstorage ou retour API de vente) => classe Product
var PRODUCT_TYPES = (_a = {},
// type_id          : ProductClass
_a[PRODUCT_TYPES_BASE.accessory] = Accessory, _a[PRODUCT_TYPES_BASE.box] = Box, _a[PRODUCT_TYPES_BASE.edpFms] = EdpFms, _a[PRODUCT_TYPES_BASE.edp] = Edp, _a[PRODUCT_TYPES_BASE.faim] = Faim, _a[PRODUCT_TYPES_BASE.faim_premium] = FaimPremium, _a[PRODUCT_TYPES_BASE.faim_unlimited] = FaimUnlimited, _a[PRODUCT_TYPES_BASE.fai_box_generique] = FaiBox, _a[PRODUCT_TYPES_BASE.fai] = Fai, _a[PRODUCT_TYPES_BASE.fai_service] = Activation, _a[PRODUCT_TYPES_BASE.fai_fmd] = Installation, _a[PRODUCT_TYPES_BASE.insurance] = Insurance, _a[PRODUCT_TYPES_BASE.option_fai] = Option, _a[PRODUCT_TYPES_BASE.option] = Option, _a[PRODUCT_TYPES_BASE.option_salable] = OptionSalable, _a[PRODUCT_TYPES_BASE.service_offer] = Option, _a[PRODUCT_TYPES_BASE.offer_partner] = OptionPartner, _a[PRODUCT_TYPES_BASE.option_partner] = OptionPartner, _a[PRODUCT_TYPES_BASE.option_remise] = OptionRemise, _a[PRODUCT_TYPES_BASE.odr] = Odr, _a[PRODUCT_TYPES_BASE.plan_ideo] = Ideo, _a[PRODUCT_TYPES_BASE.plan_ideo_pro] = Ideo, _a[PRODUCT_TYPES_BASE.plan_omb] = Omb, _a[PRODUCT_TYPES_BASE.plan_simo] = Simo, _a[PRODUCT_TYPES_BASE.plan_sowo] = Sowo, _a[PRODUCT_TYPES_BASE.plan_sowo_renew] = Sowo, _a[PRODUCT_TYPES_BASE.plan_premium] = Sensation, _a[PRODUCT_TYPES_BASE.plan_premium_renew] = Sensation, _a[PRODUCT_TYPES_BASE.phone_simple] = Phone, _a[PRODUCT_TYPES_BASE.phone] = Phone, _a[PRODUCT_TYPES_BASE.sim] = Sim, _a[PRODUCT_TYPES_BASE.shipping] = Delivery, _a[PRODUCT_TYPES_BASE._subscription] = Subscription$1, _a[PRODUCT_TYPES_BASE._equipement] = Equipment, _a[PRODUCT_TYPES_BASE._plan] = Plan, _a[PRODUCT_TYPES_BASE._product] = Product, _a[PRODUCT_TYPES_BASE['mobile-take-back']] = MobileTakeBack, _a);
var ProductFactory = /** @class */function () {
  function ProductFactory() {}
  ProductFactory.GetInstance = function (product) {
    var productTypeId = product.type_id;
    var productInstance;
    var plan = product;
    var obligation = plan.obligation_id || plan.obligation;
    switch (true) {
      case productTypeId === 'plan_sowo' && obligation && obligation !== 'none':
        productInstance = new Simo(product);
        break;
      case !!PRODUCT_TYPES[PRODUCT_TYPES_BASE[productTypeId]]:
        productInstance = new PRODUCT_TYPES[PRODUCT_TYPES_BASE[productTypeId]](product);
        break;
      default:
        console.error("Product type \"".concat(product.type_id, "\" is not set"), product);
    }
    return productInstance;
  };
  ProductFactory.Is = function (product, type, noExtend) {
    if (noExtend === void 0) {
      noExtend = false;
    }
    if (!product) {
      return false;
    }
    var classType;
    if (typeof type == 'string') {
      classType = PRODUCT_TYPES[type];
      if (!classType) {
        throw new Error("Type ".concat(type, " not define"));
      }
    } else {
      classType = type;
    }
    if (noExtend) {
      return product.constructor === classType;
    } else {
      return product instanceof classType;
    }
  };
  return ProductFactory;
}();
var UNBUNDLING_TYPES = /*#__PURE__*/function (UNBUNDLING_TYPES) {
  UNBUNDLING_TYPES["TOTAL"] = "DT";
  UNBUNDLING_TYPES["PARTIAL"] = "DP";
  return UNBUNDLING_TYPES;
}(UNBUNDLING_TYPES || {});
var PRODUCT_TYPES_FAI = /*#__PURE__*/function (PRODUCT_TYPES_FAI) {
  PRODUCT_TYPES_FAI["PRO"] = "offre_pro";
  return PRODUCT_TYPES_FAI;
}(PRODUCT_TYPES_FAI || {});
var SCORING_ACTIONS = /*#__PURE__*/function (SCORING_ACTIONS) {
  SCORING_ACTIONS["LINK"] = "lien";
  SCORING_ACTIONS["EDP"] = "supprimerEdp";
  return SCORING_ACTIONS;
}(SCORING_ACTIONS || {});
var CUSTOMER_CATEGORY = /*#__PURE__*/function (CUSTOMER_CATEGORY) {
  CUSTOMER_CATEGORY["GP"] = "GP";
  CUSTOMER_CATEGORY["PRO"] = "PRO";
  CUSTOMER_CATEGORY["ENTREPRISE"] = "ENTREPRISE";
  return CUSTOMER_CATEGORY;
}(CUSTOMER_CATEGORY || {});
var QuoteContextAcquisitionModel = /** @class */function (_super) {
  __extends(QuoteContextAcquisitionModel, _super);
  function QuoteContextAcquisitionModel(params) {
    if (params === void 0) {
      params = {};
    }
    var _this = _super.call(this, params) || this;
    _this.params = params;
    _this.id = QUOTE_CONTEXTS.ACQUISITION;
    return _this;
  }
  QuoteContextAcquisitionModel.prototype.clone = function () {
    return new QuoteContextAcquisitionModel(this.params);
  };
  return QuoteContextAcquisitionModel;
}(QuoteContextModel);
var QuoteContextFaiModel = /** @class */function (_super) {
  __extends(QuoteContextFaiModel, _super);
  function QuoteContextFaiModel(params) {
    if (params === void 0) {
      params = {};
    }
    var _this = _super.call(this, params) || this;
    _this.params = params;
    _this.id = QUOTE_CONTEXTS.ACQUISITIONFIX;
    return _this;
  }
  QuoteContextFaiModel.prototype.clone = function () {
    return new QuoteContextFaiModel(this.params);
  };
  return QuoteContextFaiModel;
}(QuoteContextModel);
var CartModel = /** @class */function () {
  function CartModel() {
    this.quotes = [];
    this.promotions = new PromotionsModel([], [], []);
    this.currentQuoteIndex = 0;
    this.isPro = false;
  }
  CartModel.prototype.getQuote = function (quoteIndex) {
    if (quoteIndex === void 0) {
      quoteIndex = this.currentQuoteIndex;
    }
    return this.quotes[quoteIndex];
  };
  CartModel.prototype.clone = function () {
    var cartClone = new CartModel();
    cartClone.quotes = this.quotes.map(function (q) {
      return q.clone();
    });
    cartClone.promotions = this.promotions.clone();
    cartClone.currentQuoteIndex = this.currentQuoteIndex;
    cartClone.isPro = this.isPro;
    cartClone.totals = this.totals;
    return cartClone;
  };
  /**
   * Calculate quotes and cart totals
   *
   * @return void
   */
  CartModel.prototype.calculateTotals = function () {
    this.totals = this.quotes.reduce(function (acc, quote) {
      var quotePrices = quote.calculateTotals();
      acc.daily.add(quotePrices.daily);
      acc.monthly.add(quotePrices.monthly);
      acc.reported.add(quotePrices.reported);
      return acc;
    }, {
      daily: new Prices(),
      monthly: new Prices(),
      reported: new Prices()
    });
  };
  CartModel.prototype.getCustomerCategory = function () {
    return this.isPro ? CUSTOMER_CATEGORY.PRO : CUSTOMER_CATEGORY.GP;
  };
  CartModel.prototype.isCartEmpty = function () {
    var cartQty = this.quotes.reduce(function (total, quote) {
      return total + quote.products.length;
    }, 0);
    return cartQty === 0;
  };
  CartModel.prototype.getAllProducts = function () {
    return [].concat.apply([], __spreadArray([], __read(this.quotes.map(function (quote) {
      return quote.products;
    })), false));
  };
  CartModel.prototype.getAllGencodes = function () {
    return [].concat.apply([], __spreadArray([], __read(this.getAllProducts().map(function (product) {
      return product.data.gencode;
    })), false));
  };
  CartModel.prototype.hasProProduct = function () {
    return this.quotes.some(function (quote) {
      return quote.hasProProduct();
    });
  };
  return CartModel;
}();
var Options = /** @class */function () {
  function Options() {}
  return Options;
}();
var QuoteModel = /** @class */function () {
  function QuoteModel(data) {
    this.context = null;
    this.forms = {};
    this.id = null;
    this.products = [];
    this.totals = null;
    Object.assign(this, data);
  }
  QuoteModel.prototype.clone = function () {
    return new QuoteModel({
      address: this.address,
      context: this.context.clone(),
      products: this.products.map(function (p) {
        return p.clone();
      })
    });
  };
  QuoteModel.prototype.addFormData = function (formData) {
    var currentFormData = this.forms;
    Object.keys(formData).forEach(function (key) {
      return currentFormData[key] = formData[key];
    });
    this.forms = currentFormData;
  };
  QuoteModel.prototype.calculateTotals = function () {
    return {
      daily: this.products.filter(function (product) {
        return product.priceType === PRICE_TYPES.Today;
      }).reduce(function (acc, product) {
        return acc.add(product.prices);
      }, new Prices()),
      monthly: this.products.filter(function (product) {
        return product.priceType === PRICE_TYPES.EveryMonth;
      }).reduce(function (acc, product) {
        return acc.add(product.prices);
      }, new Prices()),
      reported: this.products.filter(function (product) {
        return product.priceType === PRICE_TYPES.Reported;
      }).reduce(function (acc, product) {
        return acc.add(product.prices);
      }, new Prices())
    };
  };
  /**
   * Retrieve principal product by type
   */
  QuoteModel.prototype.getPrincipalProduct = function (myClass) {
    return this.getProductsByType(myClass).find(function (product) {
      return product.isPrincipal === true;
    });
  };
  /**
   * Return a specific product by gencode from quote
   */
  QuoteModel.prototype.getProductByGencode = function (gencode) {
    return this.products.find(function (product) {
      return gencode === product.data.gencode;
    });
  };
  /**
   * Return all products by gencode from quote
   */
  QuoteModel.prototype.getProductsByGencode = function (gencode) {
    return this.products.filter(function (product) {
      return gencode === product.data.gencode;
    });
  };
  /**
   * Return first product by class type for a specific quote
   * @TOOD: Replace all getProductsByType call with this one
   */
  QuoteModel.prototype.getProductByType = function (myClass) {
    var products = this.getProductsByType(myClass);
    return products.length ? products[0] : null;
  };
  /**
   * Return all products by class type for a specific quote
   */
  QuoteModel.prototype.getProductsByType = function (myClass, noExtend) {
    if (noExtend === void 0) {
      noExtend = false;
    }
    var products = this.products.filter(function (product) {
      return ProductFactory.Is(product, myClass, noExtend);
    });
    return products;
  };
  /**
   * Check if quote contains a valid combination of products
   * @return Boolean
   */
  QuoteModel.prototype.checkIsValid = function () {
    var _this = this;
    var principalProduct = this.getPrincipalProduct('Subscription');
    var missingProduct = principalProduct === null || principalProduct === void 0 ? void 0 : principalProduct.rules.mandatory.find(function (mandatoryRule) {
      return _this.products.filter(function (product) {
        return ProductFactory.Is(product, mandatoryRule.product);
      }).length === 0;
    });
    if (missingProduct) {
      throw new Error(missingProduct.message);
    }
    return true;
  };
  QuoteModel.prototype.isAcquisition = function () {
    return this.context instanceof QuoteContextAcquisitionModel;
  };
  QuoteModel.prototype.isAcquisitionFix = function () {
    return this.context instanceof QuoteContextFaiModel;
  };
  QuoteModel.prototype.isRenewal = function () {
    return this.context instanceof QuoteContextRenewalModel;
  };
  QuoteModel.prototype.isPreorder = function () {
    var _a, _b;
    var phone = this.getPrincipalProduct('Phone');
    return !!(((_a = phone === null || phone === void 0 ? void 0 : phone.data) === null || _a === void 0 ? void 0 : _a.is_preorder) && ((_b = phone === null || phone === void 0 ? void 0 : phone.data) === null || _b === void 0 ? void 0 : _b.in_stock));
  };
  QuoteModel.prototype.hasProProduct = function () {
    return this.products.some(function (product) {
      return product.isPro;
    });
  };
  return QuoteModel;
}();
function isFunction(value) {
  return typeof value === 'function';
}
function createErrorClass(createImpl) {
  var _super = function (instance) {
    Error.call(instance);
    instance.stack = new Error().stack;
  };
  var ctorFunc = createImpl(_super);
  ctorFunc.prototype = Object.create(Error.prototype);
  ctorFunc.prototype.constructor = ctorFunc;
  return ctorFunc;
}
var UnsubscriptionError = createErrorClass(function (_super) {
  return function UnsubscriptionErrorImpl(errors) {
    _super(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
      return i + 1 + ") " + err.toString();
    }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
  };
});
function arrRemove(arr, item) {
  if (arr) {
    var index = arr.indexOf(item);
    0 <= index && arr.splice(index, 1);
  }
}
var Subscription = function () {
  function Subscription(initialTeardown) {
    this.initialTeardown = initialTeardown;
    this.closed = false;
    this._parentage = null;
    this._finalizers = null;
  }
  Subscription.prototype.unsubscribe = function () {
    var e_1, _a, e_2, _b;
    var errors;
    if (!this.closed) {
      this.closed = true;
      var _parentage = this._parentage;
      if (_parentage) {
        this._parentage = null;
        if (Array.isArray(_parentage)) {
          try {
            for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
              var parent_1 = _parentage_1_1.value;
              parent_1.remove(this);
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          _parentage.remove(this);
        }
      }
      var initialFinalizer = this.initialTeardown;
      if (isFunction(initialFinalizer)) {
        try {
          initialFinalizer();
        } catch (e) {
          errors = e instanceof UnsubscriptionError ? e.errors : [e];
        }
      }
      var _finalizers = this._finalizers;
      if (_finalizers) {
        this._finalizers = null;
        try {
          for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
            var finalizer = _finalizers_1_1.value;
            try {
              execFinalizer(finalizer);
            } catch (err) {
              errors = errors !== null && errors !== void 0 ? errors : [];
              if (err instanceof UnsubscriptionError) {
                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
              } else {
                errors.push(err);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = {
            error: e_2_1
          };
        } finally {
          try {
            if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      if (errors) {
        throw new UnsubscriptionError(errors);
      }
    }
  };
  Subscription.prototype.add = function (teardown) {
    var _a;
    if (teardown && teardown !== this) {
      if (this.closed) {
        execFinalizer(teardown);
      } else {
        if (teardown instanceof Subscription) {
          if (teardown.closed || teardown._hasParent(this)) {
            return;
          }
          teardown._addParent(this);
        }
        (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
      }
    }
  };
  Subscription.prototype._hasParent = function (parent) {
    var _parentage = this._parentage;
    return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
  };
  Subscription.prototype._addParent = function (parent) {
    var _parentage = this._parentage;
    this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
  };
  Subscription.prototype._removeParent = function (parent) {
    var _parentage = this._parentage;
    if (_parentage === parent) {
      this._parentage = null;
    } else if (Array.isArray(_parentage)) {
      arrRemove(_parentage, parent);
    }
  };
  Subscription.prototype.remove = function (teardown) {
    var _finalizers = this._finalizers;
    _finalizers && arrRemove(_finalizers, teardown);
    if (teardown instanceof Subscription) {
      teardown._removeParent(this);
    }
  };
  Subscription.EMPTY = function () {
    var empty = new Subscription();
    empty.closed = true;
    return empty;
  }();
  return Subscription;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
  return value instanceof Subscription || value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe);
}
function execFinalizer(finalizer) {
  if (isFunction(finalizer)) {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
}
var config = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: undefined,
  useDeprecatedSynchronousErrorHandling: false,
  useDeprecatedNextContext: false
};
var timeoutProvider = {
  setTimeout: function (handler, timeout) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
  },
  clearTimeout: function (handle) {
    return clearTimeout(handle);
  },
  delegate: undefined
};
function reportUnhandledError(err) {
  timeoutProvider.setTimeout(function () {
    {
      throw err;
    }
  });
}
function noop() {}
function errorContext(cb) {
  {
    cb();
  }
}
var Subscriber = function (_super) {
  __extends(Subscriber, _super);
  function Subscriber(destination) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (destination) {
      _this.destination = destination;
      if (isSubscription(destination)) {
        destination.add(_this);
      }
    } else {
      _this.destination = EMPTY_OBSERVER;
    }
    return _this;
  }
  Subscriber.create = function (next, error, complete) {
    return new SafeSubscriber(next, error, complete);
  };
  Subscriber.prototype.next = function (value) {
    if (this.isStopped) ;else {
      this._next(value);
    }
  };
  Subscriber.prototype.error = function (err) {
    if (this.isStopped) ;else {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber.prototype.complete = function () {
    if (this.isStopped) ;else {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber.prototype.unsubscribe = function () {
    if (!this.closed) {
      this.isStopped = true;
      _super.prototype.unsubscribe.call(this);
      this.destination = null;
    }
  };
  Subscriber.prototype._next = function (value) {
    this.destination.next(value);
  };
  Subscriber.prototype._error = function (err) {
    try {
      this.destination.error(err);
    } finally {
      this.unsubscribe();
    }
  };
  Subscriber.prototype._complete = function () {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  };
  return Subscriber;
}(Subscription);
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
  return _bind.call(fn, thisArg);
}
var ConsumerObserver = function () {
  function ConsumerObserver(partialObserver) {
    this.partialObserver = partialObserver;
  }
  ConsumerObserver.prototype.next = function (value) {
    var partialObserver = this.partialObserver;
    if (partialObserver.next) {
      try {
        partialObserver.next(value);
      } catch (error) {
        handleUnhandledError(error);
      }
    }
  };
  ConsumerObserver.prototype.error = function (err) {
    var partialObserver = this.partialObserver;
    if (partialObserver.error) {
      try {
        partialObserver.error(err);
      } catch (error) {
        handleUnhandledError(error);
      }
    } else {
      handleUnhandledError(err);
    }
  };
  ConsumerObserver.prototype.complete = function () {
    var partialObserver = this.partialObserver;
    if (partialObserver.complete) {
      try {
        partialObserver.complete();
      } catch (error) {
        handleUnhandledError(error);
      }
    }
  };
  return ConsumerObserver;
}();
var SafeSubscriber = function (_super) {
  __extends(SafeSubscriber, _super);
  function SafeSubscriber(observerOrNext, error, complete) {
    var _this = _super.call(this) || this;
    var partialObserver;
    if (isFunction(observerOrNext) || !observerOrNext) {
      partialObserver = {
        next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
        error: error !== null && error !== void 0 ? error : undefined,
        complete: complete !== null && complete !== void 0 ? complete : undefined
      };
    } else {
      var context_1;
      if (_this && config.useDeprecatedNextContext) {
        context_1 = Object.create(observerOrNext);
        context_1.unsubscribe = function () {
          return _this.unsubscribe();
        };
        partialObserver = {
          next: observerOrNext.next && bind(observerOrNext.next, context_1),
          error: observerOrNext.error && bind(observerOrNext.error, context_1),
          complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
        };
      } else {
        partialObserver = observerOrNext;
      }
    }
    _this.destination = new ConsumerObserver(partialObserver);
    return _this;
  }
  return SafeSubscriber;
}(Subscriber);
function handleUnhandledError(error) {
  {
    reportUnhandledError(error);
  }
}
function defaultErrorHandler(err) {
  throw err;
}
var EMPTY_OBSERVER = {
  closed: true,
  next: noop,
  error: defaultErrorHandler,
  complete: noop
};
var observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
function identity(x) {
  return x;
}
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input) {
    return fns.reduce(function (prev, fn) {
      return fn(prev);
    }, input);
  };
}
var Observable = function () {
  function Observable(subscribe) {
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable.prototype.lift = function (operator) {
    var observable = new Observable();
    observable.source = this;
    observable.operator = operator;
    return observable;
  };
  Observable.prototype.subscribe = function (observerOrNext, error, complete) {
    var _this = this;
    var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
    errorContext(function () {
      var _a = _this,
        operator = _a.operator,
        source = _a.source;
      subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
    });
    return subscriber;
  };
  Observable.prototype._trySubscribe = function (sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      sink.error(err);
    }
  };
  Observable.prototype.forEach = function (next, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var subscriber = new SafeSubscriber({
        next: function (value) {
          try {
            next(value);
          } catch (err) {
            reject(err);
            subscriber.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
      _this.subscribe(subscriber);
    });
  };
  Observable.prototype._subscribe = function (subscriber) {
    var _a;
    return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
  };
  Observable.prototype[observable] = function () {
    return this;
  };
  Observable.prototype.pipe = function () {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    return pipeFromArray(operations)(this);
  };
  Observable.prototype.toPromise = function (promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var value;
      _this.subscribe(function (x) {
        return value = x;
      }, function (err) {
        return reject(err);
      }, function () {
        return resolve(value);
      });
    });
  };
  Observable.create = function (subscribe) {
    return new Observable(subscribe);
  };
  return Observable;
}();
function getPromiseCtor(promiseCtor) {
  var _a;
  return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
  return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
  return value && value instanceof Subscriber || isObserver(value) && isSubscription(value);
}
function hasLift(source) {
  return isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
  return function (source) {
    if (hasLift(source)) {
      return source.lift(function (liftedSource) {
        try {
          return init(liftedSource, this);
        } catch (err) {
          this.error(err);
        }
      });
    }
    throw new TypeError('Unable to lift unknown Observable type');
  };
}
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
  return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function (_super) {
  __extends(OperatorSubscriber, _super);
  function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
    var _this = _super.call(this, destination) || this;
    _this.onFinalize = onFinalize;
    _this.shouldUnsubscribe = shouldUnsubscribe;
    _this._next = onNext ? function (value) {
      try {
        onNext(value);
      } catch (err) {
        destination.error(err);
      }
    } : _super.prototype._next;
    _this._error = onError ? function (err) {
      try {
        onError(err);
      } catch (err) {
        destination.error(err);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._error;
    _this._complete = onComplete ? function () {
      try {
        onComplete();
      } catch (err) {
        destination.error(err);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._complete;
    return _this;
  }
  OperatorSubscriber.prototype.unsubscribe = function () {
    var _a;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var closed_1 = this.closed;
      _super.prototype.unsubscribe.call(this);
      !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
    }
  };
  return OperatorSubscriber;
}(Subscriber);
function refCount() {
  return operate(function (source, subscriber) {
    var connection = null;
    source._refCount++;
    var refCounter = createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
      if (!source || source._refCount <= 0 || 0 < --source._refCount) {
        connection = null;
        return;
      }
      var sharedConnection = source._connection;
      var conn = connection;
      connection = null;
      if (sharedConnection && (!conn || sharedConnection === conn)) {
        sharedConnection.unsubscribe();
      }
      subscriber.unsubscribe();
    });
    source.subscribe(refCounter);
    if (!refCounter.closed) {
      connection = source.connect();
    }
  });
}
(function (_super) {
  __extends(ConnectableObservable, _super);
  function ConnectableObservable(source, subjectFactory) {
    var _this = _super.call(this) || this;
    _this.source = source;
    _this.subjectFactory = subjectFactory;
    _this._subject = null;
    _this._refCount = 0;
    _this._connection = null;
    if (hasLift(source)) {
      _this.lift = source.lift;
    }
    return _this;
  }
  ConnectableObservable.prototype._subscribe = function (subscriber) {
    return this.getSubject().subscribe(subscriber);
  };
  ConnectableObservable.prototype.getSubject = function () {
    var subject = this._subject;
    if (!subject || subject.isStopped) {
      this._subject = this.subjectFactory();
    }
    return this._subject;
  };
  ConnectableObservable.prototype._teardown = function () {
    this._refCount = 0;
    var _connection = this._connection;
    this._subject = this._connection = null;
    _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
  };
  ConnectableObservable.prototype.connect = function () {
    var _this = this;
    var connection = this._connection;
    if (!connection) {
      connection = this._connection = new Subscription();
      var subject_1 = this.getSubject();
      connection.add(this.source.subscribe(createOperatorSubscriber(subject_1, undefined, function () {
        _this._teardown();
        subject_1.complete();
      }, function (err) {
        _this._teardown();
        subject_1.error(err);
      }, function () {
        return _this._teardown();
      })));
      if (connection.closed) {
        this._connection = null;
        connection = Subscription.EMPTY;
      }
    }
    return connection;
  };
  ConnectableObservable.prototype.refCount = function () {
    return refCount()(this);
  };
  return ConnectableObservable;
})(Observable);
var performanceTimestampProvider = {
  now: function () {
    return (performanceTimestampProvider.delegate || performance).now();
  },
  delegate: undefined
};
var animationFrameProvider = {
  schedule: function (callback) {
    var request = requestAnimationFrame;
    var cancel = cancelAnimationFrame;
    var handle = request(function (timestamp) {
      cancel = undefined;
      callback(timestamp);
    });
    return new Subscription(function () {
      return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
    });
  },
  requestAnimationFrame: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var delegate = animationFrameProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
  },
  cancelAnimationFrame: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return cancelAnimationFrame.apply(void 0, __spreadArray([], __read(args)));
  },
  delegate: undefined
};
function animationFramesFactory(timestampProvider) {
  return new Observable(function (subscriber) {
    var provider = timestampProvider || performanceTimestampProvider;
    var start = provider.now();
    var id = 0;
    var run = function () {
      if (!subscriber.closed) {
        id = animationFrameProvider.requestAnimationFrame(function (timestamp) {
          id = 0;
          var now = provider.now();
          subscriber.next({
            timestamp: timestampProvider ? now : timestamp,
            elapsed: now - start
          });
          run();
        });
      }
    };
    run();
    return function () {
      if (id) {
        animationFrameProvider.cancelAnimationFrame(id);
      }
    };
  });
}
animationFramesFactory();
var ObjectUnsubscribedError = createErrorClass(function (_super) {
  return function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = 'ObjectUnsubscribedError';
    this.message = 'object unsubscribed';
  };
});
var Subject = function (_super) {
  __extends(Subject, _super);
  function Subject() {
    var _this = _super.call(this) || this;
    _this.closed = false;
    _this.currentObservers = null;
    _this.observers = [];
    _this.isStopped = false;
    _this.hasError = false;
    _this.thrownError = null;
    return _this;
  }
  Subject.prototype.lift = function (operator) {
    var subject = new AnonymousSubject(this, this);
    subject.operator = operator;
    return subject;
  };
  Subject.prototype._throwIfClosed = function () {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }
  };
  Subject.prototype.next = function (value) {
    var _this = this;
    errorContext(function () {
      var e_1, _a;
      _this._throwIfClosed();
      if (!_this.isStopped) {
        if (!_this.currentObservers) {
          _this.currentObservers = Array.from(_this.observers);
        }
        try {
          for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var observer = _c.value;
            observer.next(value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
    });
  };
  Subject.prototype.error = function (err) {
    var _this = this;
    errorContext(function () {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.hasError = _this.isStopped = true;
        _this.thrownError = err;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().error(err);
        }
      }
    });
  };
  Subject.prototype.complete = function () {
    var _this = this;
    errorContext(function () {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.isStopped = true;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().complete();
        }
      }
    });
  };
  Subject.prototype.unsubscribe = function () {
    this.isStopped = this.closed = true;
    this.observers = this.currentObservers = null;
  };
  Object.defineProperty(Subject.prototype, "observed", {
    get: function () {
      var _a;
      return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
    },
    enumerable: false,
    configurable: true
  });
  Subject.prototype._trySubscribe = function (subscriber) {
    this._throwIfClosed();
    return _super.prototype._trySubscribe.call(this, subscriber);
  };
  Subject.prototype._subscribe = function (subscriber) {
    this._throwIfClosed();
    this._checkFinalizedStatuses(subscriber);
    return this._innerSubscribe(subscriber);
  };
  Subject.prototype._innerSubscribe = function (subscriber) {
    var _this = this;
    var _a = this,
      hasError = _a.hasError,
      isStopped = _a.isStopped,
      observers = _a.observers;
    if (hasError || isStopped) {
      return EMPTY_SUBSCRIPTION;
    }
    this.currentObservers = null;
    observers.push(subscriber);
    return new Subscription(function () {
      _this.currentObservers = null;
      arrRemove(observers, subscriber);
    });
  };
  Subject.prototype._checkFinalizedStatuses = function (subscriber) {
    var _a = this,
      hasError = _a.hasError,
      thrownError = _a.thrownError,
      isStopped = _a.isStopped;
    if (hasError) {
      subscriber.error(thrownError);
    } else if (isStopped) {
      subscriber.complete();
    }
  };
  Subject.prototype.asObservable = function () {
    var observable = new Observable();
    observable.source = this;
    return observable;
  };
  Subject.create = function (destination, source) {
    return new AnonymousSubject(destination, source);
  };
  return Subject;
}(Observable);
var AnonymousSubject = function (_super) {
  __extends(AnonymousSubject, _super);
  function AnonymousSubject(destination, source) {
    var _this = _super.call(this) || this;
    _this.destination = destination;
    _this.source = source;
    return _this;
  }
  AnonymousSubject.prototype.next = function (value) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
  };
  AnonymousSubject.prototype.error = function (err) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
  };
  AnonymousSubject.prototype.complete = function () {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  AnonymousSubject.prototype._subscribe = function (subscriber) {
    var _a, _b;
    return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
  };
  return AnonymousSubject;
}(Subject);
(function (_super) {
  __extends(BehaviorSubject, _super);
  function BehaviorSubject(_value) {
    var _this = _super.call(this) || this;
    _this._value = _value;
    return _this;
  }
  Object.defineProperty(BehaviorSubject.prototype, "value", {
    get: function () {
      return this.getValue();
    },
    enumerable: false,
    configurable: true
  });
  BehaviorSubject.prototype._subscribe = function (subscriber) {
    var subscription = _super.prototype._subscribe.call(this, subscriber);
    !subscription.closed && subscriber.next(this._value);
    return subscription;
  };
  BehaviorSubject.prototype.getValue = function () {
    var _a = this,
      hasError = _a.hasError,
      thrownError = _a.thrownError,
      _value = _a._value;
    if (hasError) {
      throw thrownError;
    }
    this._throwIfClosed();
    return _value;
  };
  BehaviorSubject.prototype.next = function (value) {
    _super.prototype.next.call(this, this._value = value);
  };
  return BehaviorSubject;
})(Subject);
var dateTimestampProvider = {
  now: function () {
    return (dateTimestampProvider.delegate || Date).now();
  },
  delegate: undefined
};
(function (_super) {
  __extends(ReplaySubject, _super);
  function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
    if (_bufferSize === void 0) {
      _bufferSize = Infinity;
    }
    if (_windowTime === void 0) {
      _windowTime = Infinity;
    }
    if (_timestampProvider === void 0) {
      _timestampProvider = dateTimestampProvider;
    }
    var _this = _super.call(this) || this;
    _this._bufferSize = _bufferSize;
    _this._windowTime = _windowTime;
    _this._timestampProvider = _timestampProvider;
    _this._buffer = [];
    _this._infiniteTimeWindow = true;
    _this._infiniteTimeWindow = _windowTime === Infinity;
    _this._bufferSize = Math.max(1, _bufferSize);
    _this._windowTime = Math.max(1, _windowTime);
    return _this;
  }
  ReplaySubject.prototype.next = function (value) {
    var _a = this,
      isStopped = _a.isStopped,
      _buffer = _a._buffer,
      _infiniteTimeWindow = _a._infiniteTimeWindow,
      _timestampProvider = _a._timestampProvider,
      _windowTime = _a._windowTime;
    if (!isStopped) {
      _buffer.push(value);
      !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
    }
    this._trimBuffer();
    _super.prototype.next.call(this, value);
  };
  ReplaySubject.prototype._subscribe = function (subscriber) {
    this._throwIfClosed();
    this._trimBuffer();
    var subscription = this._innerSubscribe(subscriber);
    var _a = this,
      _infiniteTimeWindow = _a._infiniteTimeWindow,
      _buffer = _a._buffer;
    var copy = _buffer.slice();
    for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
      subscriber.next(copy[i]);
    }
    this._checkFinalizedStatuses(subscriber);
    return subscription;
  };
  ReplaySubject.prototype._trimBuffer = function () {
    var _a = this,
      _bufferSize = _a._bufferSize,
      _timestampProvider = _a._timestampProvider,
      _buffer = _a._buffer,
      _infiniteTimeWindow = _a._infiniteTimeWindow;
    var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
    _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
    if (!_infiniteTimeWindow) {
      var now = _timestampProvider.now();
      var last = 0;
      for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
        last = i;
      }
      last && _buffer.splice(0, last + 1);
    }
  };
  return ReplaySubject;
})(Subject);
(function (_super) {
  __extends(AsyncSubject, _super);
  function AsyncSubject() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._value = null;
    _this._hasValue = false;
    _this._isComplete = false;
    return _this;
  }
  AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
    var _a = this,
      hasError = _a.hasError,
      _hasValue = _a._hasValue,
      _value = _a._value,
      thrownError = _a.thrownError,
      isStopped = _a.isStopped,
      _isComplete = _a._isComplete;
    if (hasError) {
      subscriber.error(thrownError);
    } else if (isStopped || _isComplete) {
      _hasValue && subscriber.next(_value);
      subscriber.complete();
    }
  };
  AsyncSubject.prototype.next = function (value) {
    if (!this.isStopped) {
      this._value = value;
      this._hasValue = true;
    }
  };
  AsyncSubject.prototype.complete = function () {
    var _a = this,
      _hasValue = _a._hasValue,
      _value = _a._value,
      _isComplete = _a._isComplete;
    if (!_isComplete) {
      this._isComplete = true;
      _hasValue && _super.prototype.next.call(this, _value);
      _super.prototype.complete.call(this);
    }
  };
  return AsyncSubject;
})(Subject);
var Action = function (_super) {
  __extends(Action, _super);
  function Action(scheduler, work) {
    return _super.call(this) || this;
  }
  Action.prototype.schedule = function (state, delay) {
    return this;
  };
  return Action;
}(Subscription);
var intervalProvider = {
  setInterval: function (handler, timeout) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
  },
  clearInterval: function (handle) {
    return clearInterval(handle);
  },
  delegate: undefined
};
var AsyncAction = function (_super) {
  __extends(AsyncAction, _super);
  function AsyncAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }
  AsyncAction.prototype.schedule = function (state, delay) {
    var _a;
    if (delay === void 0) {
      delay = 0;
    }
    if (this.closed) {
      return this;
    }
    this.state = state;
    var id = this.id;
    var scheduler = this.scheduler;
    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, delay);
    }
    this.pending = true;
    this.delay = delay;
    this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
    return this;
  };
  AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
  };
  AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay != null && this.delay === delay && this.pending === false) {
      return id;
    }
    if (id != null) {
      intervalProvider.clearInterval(id);
    }
    return undefined;
  };
  AsyncAction.prototype.execute = function (state, delay) {
    if (this.closed) {
      return new Error('executing a cancelled action');
    }
    this.pending = false;
    var error = this._execute(state, delay);
    if (error) {
      return error;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };
  AsyncAction.prototype._execute = function (state, _delay) {
    var errored = false;
    var errorValue;
    try {
      this.work(state);
    } catch (e) {
      errored = true;
      errorValue = e ? e : new Error('Scheduled action threw falsy error');
    }
    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };
  AsyncAction.prototype.unsubscribe = function () {
    if (!this.closed) {
      var _a = this,
        id = _a.id,
        scheduler = _a.scheduler;
      var actions = scheduler.actions;
      this.work = this.state = this.scheduler = null;
      this.pending = false;
      arrRemove(actions, this);
      if (id != null) {
        this.id = this.recycleAsyncId(scheduler, id, null);
      }
      this.delay = null;
      _super.prototype.unsubscribe.call(this);
    }
  };
  return AsyncAction;
}(Action);
var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
  if (handle in activeHandles) {
    delete activeHandles[handle];
    return true;
  }
  return false;
}
var Immediate = {
  setImmediate: function (cb) {
    var handle = nextHandle++;
    activeHandles[handle] = true;
    if (!resolved) {
      resolved = Promise.resolve();
    }
    resolved.then(function () {
      return findAndClearHandle(handle) && cb();
    });
    return handle;
  },
  clearImmediate: function (handle) {
    findAndClearHandle(handle);
  }
};
var setImmediate = Immediate.setImmediate,
  clearImmediate = Immediate.clearImmediate;
var immediateProvider = {
  setImmediate: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var delegate = immediateProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray([], __read(args)));
  },
  clearImmediate: function (handle) {
    return clearImmediate(handle);
  },
  delegate: undefined
};
var AsapAction = function (_super) {
  __extends(AsapAction, _super);
  function AsapAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    return _this;
  }
  AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay !== null && delay > 0) {
      return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
    }
    scheduler.actions.push(this);
    return scheduler._scheduled || (scheduler._scheduled = immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
  };
  AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
    var _a;
    if (delay === void 0) {
      delay = 0;
    }
    if (delay != null ? delay > 0 : this.delay > 0) {
      return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
    }
    var actions = scheduler.actions;
    if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
      immediateProvider.clearImmediate(id);
      if (scheduler._scheduled === id) {
        scheduler._scheduled = undefined;
      }
    }
    return undefined;
  };
  return AsapAction;
}(AsyncAction);
var Scheduler = function () {
  function Scheduler(schedulerActionCtor, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    this.schedulerActionCtor = schedulerActionCtor;
    this.now = now;
  }
  Scheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }
    return new this.schedulerActionCtor(this, work).schedule(state, delay);
  };
  Scheduler.now = dateTimestampProvider.now;
  return Scheduler;
}();
var AsyncScheduler = function (_super) {
  __extends(AsyncScheduler, _super);
  function AsyncScheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    var _this = _super.call(this, SchedulerAction, now) || this;
    _this.actions = [];
    _this._active = false;
    return _this;
  }
  AsyncScheduler.prototype.flush = function (action) {
    var actions = this.actions;
    if (this._active) {
      actions.push(action);
      return;
    }
    var error;
    this._active = true;
    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while (action = actions.shift());
    this._active = false;
    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  return AsyncScheduler;
}(Scheduler);
var AsapScheduler = function (_super) {
  __extends(AsapScheduler, _super);
  function AsapScheduler() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AsapScheduler.prototype.flush = function (action) {
    this._active = true;
    var flushId = this._scheduled;
    this._scheduled = undefined;
    var actions = this.actions;
    var error;
    action = action || actions.shift();
    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while ((action = actions[0]) && action.id === flushId && actions.shift());
    this._active = false;
    if (error) {
      while ((action = actions[0]) && action.id === flushId && actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  return AsapScheduler;
}(AsyncScheduler);
new AsapScheduler(AsapAction);
new AsyncScheduler(AsyncAction);
var QueueAction = function (_super) {
  __extends(QueueAction, _super);
  function QueueAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    return _this;
  }
  QueueAction.prototype.schedule = function (state, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay > 0) {
      return _super.prototype.schedule.call(this, state, delay);
    }
    this.delay = delay;
    this.state = state;
    this.scheduler.flush(this);
    return this;
  };
  QueueAction.prototype.execute = function (state, delay) {
    return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
  };
  QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay != null && delay > 0 || delay == null && this.delay > 0) {
      return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
    }
    scheduler.flush(this);
    return 0;
  };
  return QueueAction;
}(AsyncAction);
var QueueScheduler = function (_super) {
  __extends(QueueScheduler, _super);
  function QueueScheduler() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return QueueScheduler;
}(AsyncScheduler);
new QueueScheduler(QueueAction);
var AnimationFrameAction = function (_super) {
  __extends(AnimationFrameAction, _super);
  function AnimationFrameAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    return _this;
  }
  AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay !== null && delay > 0) {
      return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
    }
    scheduler.actions.push(this);
    return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider.requestAnimationFrame(function () {
      return scheduler.flush(undefined);
    }));
  };
  AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
    var _a;
    if (delay === void 0) {
      delay = 0;
    }
    if (delay != null ? delay > 0 : this.delay > 0) {
      return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
    }
    var actions = scheduler.actions;
    if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
      animationFrameProvider.cancelAnimationFrame(id);
      scheduler._scheduled = undefined;
    }
    return undefined;
  };
  return AnimationFrameAction;
}(AsyncAction);
var AnimationFrameScheduler = function (_super) {
  __extends(AnimationFrameScheduler, _super);
  function AnimationFrameScheduler() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AnimationFrameScheduler.prototype.flush = function (action) {
    this._active = true;
    var flushId = this._scheduled;
    this._scheduled = undefined;
    var actions = this.actions;
    var error;
    action = action || actions.shift();
    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while ((action = actions[0]) && action.id === flushId && actions.shift());
    this._active = false;
    if (error) {
      while ((action = actions[0]) && action.id === flushId && actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  return AnimationFrameScheduler;
}(AsyncScheduler);
new AnimationFrameScheduler(AnimationFrameAction);
(function (_super) {
  __extends(VirtualTimeScheduler, _super);
  function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
    if (schedulerActionCtor === void 0) {
      schedulerActionCtor = VirtualAction;
    }
    if (maxFrames === void 0) {
      maxFrames = Infinity;
    }
    var _this = _super.call(this, schedulerActionCtor, function () {
      return _this.frame;
    }) || this;
    _this.maxFrames = maxFrames;
    _this.frame = 0;
    _this.index = -1;
    return _this;
  }
  VirtualTimeScheduler.prototype.flush = function () {
    var _a = this,
      actions = _a.actions,
      maxFrames = _a.maxFrames;
    var error;
    var action;
    while ((action = actions[0]) && action.delay <= maxFrames) {
      actions.shift();
      this.frame = action.delay;
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    }
    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  VirtualTimeScheduler.frameTimeFactor = 10;
  return VirtualTimeScheduler;
})(AsyncScheduler);
var VirtualAction = function (_super) {
  __extends(VirtualAction, _super);
  function VirtualAction(scheduler, work, index) {
    if (index === void 0) {
      index = scheduler.index += 1;
    }
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    _this.index = index;
    _this.active = true;
    _this.index = scheduler.index = index;
    return _this;
  }
  VirtualAction.prototype.schedule = function (state, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (Number.isFinite(delay)) {
      if (!this.id) {
        return _super.prototype.schedule.call(this, state, delay);
      }
      this.active = false;
      var action = new VirtualAction(this.scheduler, this.work);
      this.add(action);
      return action.schedule(state, delay);
    } else {
      return Subscription.EMPTY;
    }
  };
  VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    this.delay = scheduler.frame + delay;
    var actions = scheduler.actions;
    actions.push(this);
    actions.sort(VirtualAction.sortActions);
    return 1;
  };
  VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
    return undefined;
  };
  VirtualAction.prototype._execute = function (state, delay) {
    if (this.active === true) {
      return _super.prototype._execute.call(this, state, delay);
    }
  };
  VirtualAction.sortActions = function (a, b) {
    if (a.delay === b.delay) {
      if (a.index === b.index) {
        return 0;
      } else if (a.index > b.index) {
        return 1;
      } else {
        return -1;
      }
    } else if (a.delay > b.delay) {
      return 1;
    } else {
      return -1;
    }
  };
  return VirtualAction;
}(AsyncAction);
var EMPTY = new Observable(function (subscriber) {
  return subscriber.complete();
});
function isScheduler(value) {
  return value && isFunction(value.schedule);
}
function last$1(arr) {
  return arr[arr.length - 1];
}
function popScheduler(args) {
  return isScheduler(last$1(args)) ? args.pop() : undefined;
}
var isArrayLike = function (x) {
  return x && typeof x.length === 'number' && typeof x !== 'function';
};
function isPromise(value) {
  return isFunction(value === null || value === void 0 ? void 0 : value.then);
}
function isInteropObservable(input) {
  return isFunction(input[observable]);
}
function isAsyncIterable(obj) {
  return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
function createInvalidObservableTypeError(input) {
  return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function getSymbolIterator() {
  if (typeof Symbol !== 'function' || !Symbol.iterator) {
    return '@@iterator';
  }
  return Symbol.iterator;
}
var iterator = getSymbolIterator();
function isIterable(input) {
  return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
}
function readableStreamLikeToAsyncGenerator(readableStream) {
  return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
    var reader, _a, value, done;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          reader = readableStream.getReader();
          _b.label = 1;
        case 1:
          _b.trys.push([1,, 9, 10]);
          _b.label = 2;
        case 2:
          return [4, __await(reader.read())];
        case 3:
          _a = _b.sent(), value = _a.value, done = _a.done;
          if (!done) return [3, 5];
          return [4, __await(void 0)];
        case 4:
          return [2, _b.sent()];
        case 5:
          return [4, __await(value)];
        case 6:
          return [4, _b.sent()];
        case 7:
          _b.sent();
          return [3, 2];
        case 8:
          return [3, 10];
        case 9:
          reader.releaseLock();
          return [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(obj) {
  return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
function innerFrom(input) {
  if (input instanceof Observable) {
    return input;
  }
  if (input != null) {
    if (isInteropObservable(input)) {
      return fromInteropObservable(input);
    }
    if (isArrayLike(input)) {
      return fromArrayLike(input);
    }
    if (isPromise(input)) {
      return fromPromise(input);
    }
    if (isAsyncIterable(input)) {
      return fromAsyncIterable(input);
    }
    if (isIterable(input)) {
      return fromIterable(input);
    }
    if (isReadableStreamLike(input)) {
      return fromReadableStreamLike(input);
    }
  }
  throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
  return new Observable(function (subscriber) {
    var obs = obj[observable]();
    if (isFunction(obs.subscribe)) {
      return obs.subscribe(subscriber);
    }
    throw new TypeError('Provided object does not correctly implement Symbol.observable');
  });
}
function fromArrayLike(array) {
  return new Observable(function (subscriber) {
    for (var i = 0; i < array.length && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }
    subscriber.complete();
  });
}
function fromPromise(promise) {
  return new Observable(function (subscriber) {
    promise.then(function (value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function (err) {
      return subscriber.error(err);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(iterable) {
  return new Observable(function (subscriber) {
    var e_1, _a;
    try {
      for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
        var value = iterable_1_1.value;
        subscriber.next(value);
        if (subscriber.closed) {
          return;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    subscriber.complete();
  });
}
function fromAsyncIterable(asyncIterable) {
  return new Observable(function (subscriber) {
    process(asyncIterable, subscriber).catch(function (err) {
      return subscriber.error(err);
    });
  });
}
function fromReadableStreamLike(readableStream) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process(asyncIterable, subscriber) {
  var asyncIterable_1, asyncIterable_1_1;
  var e_2, _a;
  return __awaiter(this, void 0, void 0, function () {
    var value, e_2_1;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 5, 6, 11]);
          asyncIterable_1 = __asyncValues(asyncIterable);
          _b.label = 1;
        case 1:
          return [4, asyncIterable_1.next()];
        case 2:
          if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
          value = asyncIterable_1_1.value;
          subscriber.next(value);
          if (subscriber.closed) {
            return [2];
          }
          _b.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          e_2_1 = _b.sent();
          e_2 = {
            error: e_2_1
          };
          return [3, 11];
        case 6:
          _b.trys.push([6,, 9, 10]);
          if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
          return [4, _a.call(asyncIterable_1)];
        case 7:
          _b.sent();
          _b.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (e_2) throw e_2.error;
          return [7];
        case 10:
          return [7];
        case 11:
          subscriber.complete();
          return [2];
      }
    });
  });
}
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
  if (delay === void 0) {
    delay = 0;
  }
  if (repeat === void 0) {
    repeat = false;
  }
  var scheduleSubscription = scheduler.schedule(function () {
    work();
    if (repeat) {
      parentSubscription.add(this.schedule(null, delay));
    } else {
      this.unsubscribe();
    }
  }, delay);
  parentSubscription.add(scheduleSubscription);
  if (!repeat) {
    return scheduleSubscription;
  }
}
function observeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return operate(function (source, subscriber) {
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      return executeSchedule(subscriber, scheduler, function () {
        return subscriber.next(value);
      }, delay);
    }, function () {
      return executeSchedule(subscriber, scheduler, function () {
        return subscriber.complete();
      }, delay);
    }, function (err) {
      return executeSchedule(subscriber, scheduler, function () {
        return subscriber.error(err);
      }, delay);
    }));
  });
}
function subscribeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return operate(function (source, subscriber) {
    subscriber.add(scheduler.schedule(function () {
      return source.subscribe(subscriber);
    }, delay));
  });
}
function scheduleObservable(input, scheduler) {
  return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}
function schedulePromise(input, scheduler) {
  return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}
function scheduleArray(input, scheduler) {
  return new Observable(function (subscriber) {
    var i = 0;
    return scheduler.schedule(function () {
      if (i === input.length) {
        subscriber.complete();
      } else {
        subscriber.next(input[i++]);
        if (!subscriber.closed) {
          this.schedule();
        }
      }
    });
  });
}
function scheduleIterable(input, scheduler) {
  return new Observable(function (subscriber) {
    var iterator$1;
    executeSchedule(subscriber, scheduler, function () {
      iterator$1 = input[iterator]();
      executeSchedule(subscriber, scheduler, function () {
        var _a;
        var value;
        var done;
        try {
          _a = iterator$1.next(), value = _a.value, done = _a.done;
        } catch (err) {
          subscriber.error(err);
          return;
        }
        if (done) {
          subscriber.complete();
        } else {
          subscriber.next(value);
        }
      }, 0, true);
    });
    return function () {
      return isFunction(iterator$1 === null || iterator$1 === void 0 ? void 0 : iterator$1.return) && iterator$1.return();
    };
  });
}
function scheduleAsyncIterable(input, scheduler) {
  if (!input) {
    throw new Error('Iterable cannot be null');
  }
  return new Observable(function (subscriber) {
    executeSchedule(subscriber, scheduler, function () {
      var iterator = input[Symbol.asyncIterator]();
      executeSchedule(subscriber, scheduler, function () {
        iterator.next().then(function (result) {
          if (result.done) {
            subscriber.complete();
          } else {
            subscriber.next(result.value);
          }
        });
      }, 0, true);
    });
  });
}
function scheduleReadableStreamLike(input, scheduler) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
}
function scheduled(input, scheduler) {
  if (input != null) {
    if (isInteropObservable(input)) {
      return scheduleObservable(input, scheduler);
    }
    if (isArrayLike(input)) {
      return scheduleArray(input, scheduler);
    }
    if (isPromise(input)) {
      return schedulePromise(input, scheduler);
    }
    if (isAsyncIterable(input)) {
      return scheduleAsyncIterable(input, scheduler);
    }
    if (isIterable(input)) {
      return scheduleIterable(input, scheduler);
    }
    if (isReadableStreamLike(input)) {
      return scheduleReadableStreamLike(input, scheduler);
    }
  }
  throw createInvalidObservableTypeError(input);
}
function from(input, scheduler) {
  return scheduler ? scheduled(input, scheduler) : innerFrom(input);
}
function of() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var scheduler = popScheduler(args);
  return from(args, scheduler);
}
function throwError(errorOrErrorFactory, scheduler) {
  var errorFactory = isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function () {
    return errorOrErrorFactory;
  };
  var init = function (subscriber) {
    return subscriber.error(errorFactory());
  };
  return new Observable(scheduler ? function (subscriber) {
    return scheduler.schedule(init, 0, subscriber);
  } : init);
}
var NotificationKind = /*#__PURE__*/function (NotificationKind) {
  NotificationKind["NEXT"] = "N";
  NotificationKind["ERROR"] = "E";
  NotificationKind["COMPLETE"] = "C";
  return NotificationKind;
}(NotificationKind || {});
var EmptyError = createErrorClass(function (_super) {
  return function EmptyErrorImpl() {
    _super(this);
    this.name = 'EmptyError';
    this.message = 'no elements in sequence';
  };
});
function lastValueFrom(source, config) {
  var hasConfig = typeof config === 'object';
  return new Promise(function (resolve, reject) {
    var _hasValue = false;
    var _value;
    source.subscribe({
      next: function (value) {
        _value = value;
        _hasValue = true;
      },
      error: reject,
      complete: function () {
        if (_hasValue) {
          resolve(_value);
        } else if (hasConfig) {
          resolve(config.defaultValue);
        } else {
          reject(new EmptyError());
        }
      }
    });
  });
}
createErrorClass(function (_super) {
  return function ArgumentOutOfRangeErrorImpl() {
    _super(this);
    this.name = 'ArgumentOutOfRangeError';
    this.message = 'argument out of range';
  };
});
createErrorClass(function (_super) {
  return function NotFoundErrorImpl(message) {
    _super(this);
    this.name = 'NotFoundError';
    this.message = message;
  };
});
createErrorClass(function (_super) {
  return function SequenceErrorImpl(message) {
    _super(this);
    this.name = 'SequenceError';
    this.message = message;
  };
});
createErrorClass(function (_super) {
  return function TimeoutErrorImpl(info) {
    if (info === void 0) {
      info = null;
    }
    _super(this);
    this.message = 'Timeout has occurred';
    this.name = 'TimeoutError';
    this.info = info;
  };
});
function map(project, thisArg) {
  return operate(function (source, subscriber) {
    var index = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      subscriber.next(project.call(thisArg, value, index++));
    }));
  });
}
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
  var buffer = [];
  var active = 0;
  var index = 0;
  var isComplete = false;
  var checkComplete = function () {
    if (isComplete && !buffer.length && !active) {
      subscriber.complete();
    }
  };
  var outerNext = function (value) {
    return active < concurrent ? doInnerSub(value) : buffer.push(value);
  };
  var doInnerSub = function (value) {
    expand && subscriber.next(value);
    active++;
    var innerComplete = false;
    innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
      onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
      if (expand) {
        outerNext(innerValue);
      } else {
        subscriber.next(innerValue);
      }
    }, function () {
      innerComplete = true;
    }, undefined, function () {
      if (innerComplete) {
        try {
          active--;
          var _loop_1 = function () {
            var bufferedValue = buffer.shift();
            if (innerSubScheduler) {
              executeSchedule(subscriber, innerSubScheduler, function () {
                return doInnerSub(bufferedValue);
              });
            } else {
              doInnerSub(bufferedValue);
            }
          };
          while (buffer.length && active < concurrent) {
            _loop_1();
          }
          checkComplete();
        } catch (err) {
          subscriber.error(err);
        }
      }
    }));
  };
  source.subscribe(createOperatorSubscriber(subscriber, outerNext, function () {
    isComplete = true;
    checkComplete();
  }));
  return function () {
    additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
  };
}
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  if (isFunction(resultSelector)) {
    return mergeMap(function (a, i) {
      return map(function (b, ii) {
        return resultSelector(a, b, i, ii);
      })(innerFrom(project(a, i)));
    }, concurrent);
  } else if (typeof resultSelector === 'number') {
    concurrent = resultSelector;
  }
  return operate(function (source, subscriber) {
    return mergeInternals(source, subscriber, project, concurrent);
  });
}
new Observable(noop);
function filter(predicate, thisArg) {
  return operate(function (source, subscriber) {
    var index = 0;
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      return predicate.call(thisArg, value, index++) && subscriber.next(value);
    }));
  });
}
function defaultIfEmpty(defaultValue) {
  return operate(function (source, subscriber) {
    var hasValue = false;
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      hasValue = true;
      subscriber.next(value);
    }, function () {
      if (!hasValue) {
        subscriber.next(defaultValue);
      }
      subscriber.complete();
    }));
  });
}
function throwIfEmpty(errorFactory) {
  if (errorFactory === void 0) {
    errorFactory = defaultErrorFactory;
  }
  return operate(function (source, subscriber) {
    var hasValue = false;
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      hasValue = true;
      subscriber.next(value);
    }, function () {
      return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
    }));
  });
}
function defaultErrorFactory() {
  return new EmptyError();
}
function takeLast(count) {
  return count <= 0 ? function () {
    return EMPTY;
  } : operate(function (source, subscriber) {
    var buffer = [];
    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
      buffer.push(value);
      count < buffer.length && buffer.shift();
    }, function () {
      var e_1, _a;
      try {
        for (var buffer_1 = __values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
          var value = buffer_1_1.value;
          subscriber.next(value);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
      subscriber.complete();
    }, undefined, function () {
      buffer = null;
    }));
  });
}
function last(predicate, defaultValue) {
  var hasDefaultValue = arguments.length >= 2;
  return function (source) {
    return source.pipe(predicate ? filter(function (v, i) {
      return predicate(v, i, source);
    }) : identity, takeLast(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () {
      return new EmptyError();
    }));
  };
}
var PromotionsService = /** @class */function () {
  function PromotionsService() {}
  PromotionsService.GetPromotionsForProduct = function (product, promotions) {
    var _this = this;
    var couponPromo = promotions.coupon;
    return new PromotionsModel(promotions.automatic.filter(function (p) {
      return _this.isApplicable(product, p);
    }), promotions.manual.filter(function (p) {
      return _this.isApplicable(product, p);
    }), promotions.incitation.filter(function (p) {
      return _this.isApplicable(product, p);
    }), couponPromo && this.isApplicable(product, couponPromo) ? couponPromo : null);
  };
  PromotionsService.isApplicable = function (product, promotion) {
    return promotion.relevantProducts.includes(product.gencode);
  };
  return PromotionsService;
}();
var QuoteService = /** @class */function () {
  function QuoteService() {}
  /**
   * Add product to current quote by gencode
   */
  QuoteService.prototype.addProduct = function (quote, product) {
    var _this = this;
    if (!product || !product.canAdd(quote)) {
      return this;
    }
    product.getIncompatible(quote).forEach(function (p) {
      return _this.removeProduct(quote, p, product);
    });
    product.beforeAdd(this, quote);
    quote.products.push(product);
    product.afterAdd(this, quote);
    quote.products.forEach(function (productQuote) {
      return productQuote.onItemAddedInQuote(quote, product);
    });
    return this;
  };
  QuoteService.prototype.removeProduct = function (quote, product, removedBy) {
    var _this = this;
    if (removedBy === void 0) {
      removedBy = null;
    }
    if (!product) {
      return this;
    }
    quote.products = quote.products.filter(function (quoteProduct) {
      return quoteProduct !== product;
    });
    product.afterRemove(this, quote);
    product.getRelated(quote).filter(function (p) {
      return !removedBy || !removedBy.keepProduct(quote, p);
    }).forEach(function (p) {
      return _this.removeProduct(quote, p, removedBy);
    });
    product.getAutoAdded(quote).filter(function (p) {
      return !removedBy || !removedBy.keepProduct(quote, p);
    }).forEach(function (p) {
      return _this.removeProduct(quote, p, removedBy);
    });
    quote.products.forEach(function (productQuote) {
      return productQuote.onItemRemovedFromQuote(quote, product);
    });
    return this;
  };
  QuoteService.prototype.removeProductsByType = function (quote, productType, noExtend) {
    var _this = this;
    if (noExtend === void 0) {
      noExtend = false;
    }
    quote.getProductsByType(productType, noExtend).forEach(function (product) {
      return _this.removeProduct(quote, product);
    });
    return this;
  };
  QuoteService.prototype.removeProductByGencode = function (quote, gencode) {
    this.removeProduct(quote, quote.getProductByGencode(gencode));
    return this;
  };
  QuoteService.prototype.removeProductsByGencode = function (quote, gencodes) {
    var _this = this;
    gencodes.forEach(function (gencode) {
      return _this.removeProductByGencode(quote, gencode);
    });
    return this;
  };
  QuoteService.prototype.refresh = function (quote) {
    var _this = this;
    quote.products.forEach(function (product) {
      return product.refresh(_this, quote);
    });
    quote.totals = quote.calculateTotals();
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  QuoteService.prototype.calculatePrices = function (quote, promotions) {
    quote.products.forEach(function (product) {
      return product.calculatePrices(quote, PromotionsService.GetPromotionsForProduct(product, promotions));
    });
    // When you have promotion on quote...
  };
  return QuoteService;
}();
var CartService = /** @class */function () {
  function CartService(promotionRepository, productRepository) {
    this.promotionRepository = promotionRepository;
    this.productRepository = productRepository;
    this.quoteService = new QuoteService();
  }
  /**
   * Add product to current quote by gencode
   */
  CartService.prototype.addProduct = function (cart, product, quoteIndex, autoRefresh) {
    var _this = this;
    var _a;
    if (quoteIndex === void 0) {
      quoteIndex = cart.currentQuoteIndex;
    }
    if (autoRefresh === void 0) {
      autoRefresh = true;
    }
    if (!product) {
      return of(null);
    }
    if (!cart.quotes[quoteIndex]) {
      this.addQuote(cart);
    }
    var quote = cart.quotes[quoteIndex];
    // Prevent add of product incompatible with current scoring
    try {
      this.quoteService.addProduct(quote, product);
    } catch (e) {
      return throwError(function () {
        return {
          level: ERRORS_LEVELS.error,
          message: e.message
        };
      });
    }
    var autoAddObs = of(product);
    if ((_a = product === null || product === void 0 ? void 0 : product.autoAddFront) === null || _a === void 0 ? void 0 : _a.length) {
      var filteredAutoAdd = product.autoAddFront.filter(function (autoAdd) {
        var _a, _b;
        return ((_a = autoAdd.conditions) === null || _a === void 0 ? void 0 : _a.typeParcours) === quote.context.id || !((_b = autoAdd.conditions) === null || _b === void 0 ? void 0 : _b.typeParcours);
      });
      autoAddObs = from(filteredAutoAdd).pipe(mergeMap(function (autoAddFront) {
        return _this.productRepository.getProductByGencode(autoAddFront.alternatives.map(function (el) {
          return el;
        }).join(','));
      }), filter(function (productAutoAdd) {
        var _a, _b;
        return !((_b = (_a = productAutoAdd === null || productAutoAdd === void 0 ? void 0 : productAutoAdd.autoAddFront) === null || _a === void 0 ? void 0 : _a.flatMap(function (el) {
          return el.alternatives;
        })) === null || _b === void 0 ? void 0 : _b.includes(product.data.gencode));
      }), mergeMap(function (productAutoAdd) {
        return _this.addProduct(cart, productAutoAdd, quoteIndex, false);
      }));
    }
    return autoAddObs.pipe(last(), mergeMap(function () {
      return autoRefresh ? from(_this.refresh(cart)) : of(null);
    }), map(function () {
      return product;
    }));
  };
  CartService.prototype.addQuote = function (cart, context) {
    if (context === void 0) {
      context = new QuoteContextAcquisitionModel();
    }
    var quote = new QuoteModel({
      products: [],
      context: context,
      address: {
        shipping: null,
        billing: null
      },
      forms: {}
    });
    cart.quotes.push(quote);
    return cart.quotes.length - 1;
  };
  CartService.prototype.removeQuote = function (cart, quoteIndex) {
    if (quoteIndex === void 0) {
      quoteIndex = 0;
    }
    cart.quotes = cart.quotes.filter(function (quote, index) {
      return index !== quoteIndex;
    });
    return from(this.refresh(cart));
  };
  CartService.prototype.clear = function (cart) {
    cart.totals = null;
    cart.currentQuoteIndex = 0;
    cart.promotions = new PromotionsModel([], [], []);
    cart.quotes = [];
  };
  /**
   * Return all products by type from cart (all quotes)
   */
  CartService.prototype.getAllProductsByType = function (cart, myClass) {
    var allProduct = [];
    cart.quotes.forEach(function (quote) {
      allProduct = allProduct.concat(quote.getProductsByType(myClass));
    });
    return allProduct;
  };
  CartService.prototype.getQuote = function (cart, quoteIndex) {
    if (quoteIndex === void 0) {
      quoteIndex = cart.currentQuoteIndex;
    }
    return cart.getQuote(quoteIndex);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  CartService.prototype.calculatePrices = function (cart) {
    var _this = this;
    cart.quotes.forEach(function (quote) {
      return _this.quoteService.calculatePrices(quote, cart.promotions);
    });
  };
  CartService.prototype.refresh = function (cart) {
    return __awaiter(this, void 0, void 0, function () {
      var promotions;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, lastValueFrom(this.promotionRepository.getPromotionsForCart(cart))];
          case 1:
            promotions = _a.sent();
            promotions.manual = cart.promotions.manual;
            promotions.coupon = cart.promotions.coupon;
            cart.promotions = promotions;
            cart.quotes.forEach(function (quote) {
              return _this.quoteService.refresh(quote);
            });
            this.calculatePrices(cart);
            cart.calculateTotals();
            return [2 /*return*/];
        }
      });
    });
  };
  CartService.prototype.removeManualPromotion = function (cart, manualPromotion) {
    cart.promotions.removeManual(manualPromotion);
    this.calculatePrices(cart);
    return from(this.refresh(cart));
  };
  CartService.prototype.addManualPromotion = function (cart, manualPromotion) {
    cart.promotions.addManual(manualPromotion);
    this.calculatePrices(cart);
    return from(this.refresh(cart));
  };
  CartService.prototype.removeCouponPromotion = function (cart, refresh) {
    if (refresh === void 0) {
      refresh = true;
    }
    cart.promotions.removeCoupon();
    return refresh ? from(this.refresh(cart)) : of(null);
  };
  CartService.prototype.setCouponPromotion = function (cart, promotion) {
    cart.promotions.setCoupon(promotion);
    return from(this.refresh(cart));
  };
  /**
   * Remove product from specific quote by gencode
   * @return Observable
   */
  CartService.prototype.removeProduct = function (cart, product, quoteIndex, autoRefresh) {
    var _this = this;
    var _a;
    if (quoteIndex === void 0) {
      quoteIndex = cart.currentQuoteIndex;
    }
    if (autoRefresh === void 0) {
      autoRefresh = true;
    }
    // Remove product and related products
    if (!product) {
      return of(null);
    }
    var quote = cart.quotes[quoteIndex];
    this.quoteService.removeProduct(quote, product);
    var autoRemoveObs = of(product);
    if ((_a = product === null || product === void 0 ? void 0 : product.autoAddFront) === null || _a === void 0 ? void 0 : _a.length) {
      autoRemoveObs = from(product.autoAddFront || []).pipe(mergeMap(function (autoAddFront) {
        return _this.removeProduct(cart, cart.getQuote(quoteIndex).getProductByGencode(autoAddFront.alternatives.map(function (el) {
          return el;
        }).join(',')), quoteIndex, false);
      }));
    }
    return autoRemoveObs.pipe(last(), mergeMap(function () {
      return autoRefresh ? from(_this.refresh(cart)) : of(null);
    }), map(function () {
      return product;
    }));
  };
  return CartService;
}();
export { ACCESS_TYPE, Accessory, Activation, Box, CUSTOMER_CATEGORY, CartModel, CartService, Delivery, ERRORS_LEVELS, Edp, EdpFms, Equipment, Fai, FaiBox, Faim, FaimPremium, FaimUnlimited, IS_LOADING_CLASS, Ideo, Installation, Insurance, MARKET_TYPE, MobileTakeBack, OPTION_LOCKED_ID, Odr, Omb, Option, OptionPartner, OptionRemise, OptionSalable, Options, PRICE_TYPES, PRODUCT_TYPES, PRODUCT_TYPES_BASE, PRODUCT_TYPES_FAI, Phone, Plan, Prices, Product, ProductFactory, PromotionModel, PromotionOdrModel, PromotionsModel, PromotionsService, QUOTE_CONTEXTS, QuoteContextAcquisitionModel, QuoteContextFaiModel, QuoteContextModel, QuoteContextRenewalModel, QuoteModel, QuoteService, REDUCTION_TYPE, RENEW_CLIENT_TYPES, RENEW_NB_TERMS, SCORING_ACTIONS, SIM_PORTABILITY, Sensation, Sim, Simo, Sowo, Subscription$1 as Subscription, TYPE_MARKETING, UNBUNDLING_TYPES, UPDATE_ACTIONS };
